export const airlines = [
    {
        "name": "Riyadh Air",
        "code": "RX",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/RX@2x.png"
    },
    {
        "name": "Lanmei Airlines",
        "code": "LQ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/LQ@2x.png"
    },
    {
        "name": "Air Uganda",
        "code": "U7",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/U7@2x.png"
    },
    {
        "name": "Cubana de Aviaci\u00f3n",
        "code": "CU",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/CU@2x.png"
    },
    {
        "name": "Jonika Airlines",
        "code": "JO",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/JO@2x.png"
    },
    {
        "name": "Russian Railways",
        "code": "R0",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/R0@2x.png"
    },
    {
        "name": "Middle East Airlines",
        "code": "ME",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/ME@2x.png"
    },
    {
        "name": "Donghai Airlines",
        "code": "DZ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/DZ@2x.png"
    },
    {
        "name": "CommutAir",
        "code": "C5",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/C5@2x.png"
    },
    {
        "name": "Amtrak",
        "code": "2V",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/2V@2x.png"
    },
    {
        "name": "Ellinair",
        "code": "EL",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/EL@2x.png"
    },
    {
        "name": "TAAG Angola Airlines",
        "code": "DT",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/DT@2x.png"
    },
    {
        "name": "Zapways, Inc.",
        "code": "R1",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/R1@2x.png"
    },
    {
        "name": "TAG Airlines",
        "code": "5U",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/5U@2x.png"
    },
    {
        "name": "Norse Atlantic UK",
        "code": "Z0",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/Z0@2x.png"
    },
    {
        "name": "US Airways",
        "code": "US",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/US@2x.png"
    },
    {
        "name": "Pacific Wings",
        "code": "LW",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/LW@2x.png"
    },
    {
        "name": "AHK Air Hong Kong Limited",
        "code": "LD",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/LD@2x.png"
    },
    {
        "name": "Jet Asia Airways",
        "code": "JF",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/JF@2x.png"
    },
    {
        "name": "Austral Lineas Aereas",
        "code": "AU",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/AU@2x.png"
    },
    {
        "name": "HiSky",
        "code": "H4",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/H4@2x.png"
    },
    {
        "name": "Hawkair",
        "code": "BH",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/BH@2x.png"
    },
    {
        "name": "Lynden Air Cargo, LLC",
        "code": "L2",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/L2@2x.png"
    },
    {
        "name": "Apsara International Air",
        "code": "IP",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/IP@2x.png"
    },
    {
        "name": "Georgian Airways",
        "code": "A9",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/A9@2x.png"
    },
    {
        "name": "Sky Lease I, Inc.",
        "code": "GG",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/GG@2x.png"
    },
    {
        "name": "Skypower Express Airways",
        "code": "NB",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/NB@2x.png"
    },
    {
        "name": "Viva Air Colombia",
        "code": "VH",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/VH@2x.png"
    },
    {
        "name": "Air City",
        "code": "4F",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/4F@2x.png"
    },
    {
        "name": "Lufthansa",
        "code": "LH",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/LH@2x.png"
    },
    {
        "name": "Polar Airlines",
        "code": "PI",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/PI@2x.png"
    },
    {
        "name": "Air Arabia Egypt",
        "code": "E5",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/E5@2x.png"
    },
    {
        "name": "Palau National Airlines",
        "code": "4L",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/4L@2x.png"
    },
    {
        "name": "LGW Luftfahrtgesellschaft Walter",
        "code": "HE",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/HE@2x.png"
    },
    {
        "name": "Air Arabia Abu Dhabi",
        "code": "3L",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/3L@2x.png"
    },
    {
        "name": "Eaglexpress Air Charter Sdn.Bhd.dbaEaglexpress Air",
        "code": "9A",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/9A@2x.png"
    },
    {
        "name": "Australian Airlines",
        "code": "AO",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/AO@2x.png"
    },
    {
        "name": "Southwind",
        "code": "2S",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/2S@2x.png"
    },
    {
        "name": "Bringer Air Cargo",
        "code": "E6",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/E6@2x.png"
    },
    {
        "name": "Royal Nepal Airlines",
        "code": "RA",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/RA@2x.png"
    },
    {
        "name": "Asia Atlantic Airlines",
        "code": "HB",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/HB@2x.png"
    },
    {
        "name": "North-Wright Airways",
        "code": "HW",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/HW@2x.png"
    },
    {
        "name": "Transair Senegal",
        "code": "R2",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/R2@2x.png"
    },
    {
        "name": "Air Jet",
        "code": "7A",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/7A@2x.png"
    },
    {
        "name": "AirBridgeCargo",
        "code": "RU",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/RU@2x.png"
    },
    {
        "name": "Polynesian Airlines",
        "code": "OL",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/OL@2x.png"
    },
    {
        "name": "InterCaribbean Airways",
        "code": "JY",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/JY@2x.png"
    },
    {
        "name": "Mauritania Airlines International",
        "code": "L6",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/L6@2x.png"
    },
    {
        "name": "SiAvia",
        "code": "KT",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/KT@2x.png"
    },
    {
        "name": "Norwegian Long Haul",
        "code": "DU",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/DU@2x.png"
    },
    {
        "name": "SpiceJet",
        "code": "SG",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/SG@2x.png"
    },
    {
        "name": "Sounds Air Travel & Tourism Ltd.",
        "code": "S8",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/S8@2x.png"
    },
    {
        "name": "Aserca Airlines",
        "code": "R7",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/R7@2x.png"
    },
    {
        "name": "Air Koryo",
        "code": "JS",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/JS@2x.png"
    },
    {
        "name": "Air Mauritius",
        "code": "MK",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/MK@2x.png"
    },
    {
        "name": "Auric Air",
        "code": "UI",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/UI@2x.png"
    },
    {
        "name": "Air Caledonie",
        "code": "TY",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/TY@2x.png"
    },
    {
        "name": "Wizz Air",
        "code": "W9",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/W9@2x.png"
    },
    {
        "name": "Air Rarotonga",
        "code": "GZ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/GZ@2x.png"
    },
    {
        "name": "Federal Air",
        "code": "7V",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/7V@2x.png"
    },
    {
        "name": "IHY Izmir Havayollari A.S.",
        "code": "4I",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/4I@2x.png"
    },
    {
        "name": "Polar Air Cargo Worldwide, Inc.",
        "code": "PO",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/PO@2x.png"
    },
    {
        "name": "Trans Air Congo",
        "code": "Q8",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/Q8@2x.png"
    },
    {
        "name": "New England Airlines",
        "code": "EJ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/EJ@2x.png"
    },
    {
        "name": "Air Samarkand",
        "code": "9S",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/9S@2x.png"
    },
    {
        "name": "TUI Airlines Netherlands",
        "code": "OR",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/OR@2x.png"
    },
    {
        "name": "South East Asian Airlines (SEAIR)International, Inc.",
        "code": "XO",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/XO@2x.png"
    },
    {
        "name": "Southern Air",
        "code": "9R",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/9R@2x.png"
    },
    {
        "name": "Air Dilijans",
        "code": "RM",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/RM@2x.png"
    },
    {
        "name": "Air North Charter and Training Ltd.",
        "code": "4N",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/4N@2x.png"
    },
    {
        "name": "MYAirline",
        "code": "Z9",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/Z9@2x.png"
    },
    {
        "name": "Malawian Airlines",
        "code": "3W",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/3W@2x.png"
    },
    {
        "name": "Jet Ops",
        "code": "J6",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/J6@2x.png"
    },
    {
        "name": "Lao Airlines",
        "code": "QV",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/QV@2x.png"
    },
    {
        "name": "Bamboo Airways",
        "code": "QH",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/QH@2x.png"
    },
    {
        "name": "airblue",
        "code": "PA",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/PA@2x.png"
    },
    {
        "name": "Aerov\u00edas DAP",
        "code": "V5",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/V5@2x.png"
    },
    {
        "name": "Sepehran Airlines",
        "code": "IS",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/IS@2x.png"
    },
    {
        "name": "Air Serbia",
        "code": "JU",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/JU@2x.png"
    },
    {
        "name": "Aerolineas Argentinas",
        "code": "AR",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/AR@2x.png"
    },
    {
        "name": "Airshop B.V.",
        "code": "FF",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/FF@2x.png"
    },
    {
        "name": "Primera Air",
        "code": "PF",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/PF@2x.png"
    },
    {
        "name": "Royal Zambian Airlines",
        "code": "3Q",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/3Q@2x.png"
    },
    {
        "name": "Major Airline",
        "code": "XX",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/XX@2x.png"
    },
    {
        "name": "Sunsplash Aviation, LLC.",
        "code": "YH",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/YH@2x.png"
    },
    {
        "name": "Titan Airways Limited",
        "code": "ZT",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/ZT@2x.png"
    },
    {
        "name": "Cambodia Airways",
        "code": "KR",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/KR@2x.png"
    },
    {
        "name": "China Cargo Airlines",
        "code": "CK",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/CK@2x.png"
    },
    {
        "name": "Conquest Air, Inc.",
        "code": "C4",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/C4@2x.png"
    },
    {
        "name": "Air Iceland",
        "code": "NY",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/NY@2x.png"
    },
    {
        "name": "Siam Ga Co. Ltd.",
        "code": "5E",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/5E@2x.png"
    },
    {
        "name": "Super Air Jet",
        "code": "IU",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/IU@2x.png"
    },
    {
        "name": "Azur Air Ukraine",
        "code": "QU",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/QU@2x.png"
    },
    {
        "name": "Sudan Airways",
        "code": "SD",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/SD@2x.png"
    },
    {
        "name": "Alliance Airlines",
        "code": "QQ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/QQ@2x.png"
    },
    {
        "name": "Andes Lineas Aereas",
        "code": "OY",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/OY@2x.png"
    },
    {
        "name": "JetHunter",
        "code": "01",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/01@2x.png"
    },
    {
        "name": "Marathon Airlines",
        "code": "O8",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/O8@2x.png"
    },
    {
        "name": "Seaborne Airlines",
        "code": "BB",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/BB@2x.png"
    },
    {
        "name": "Uzbekistan Airways Express",
        "code": "0H",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/0H@2x.png"
    },
    {
        "name": "Ryanair UK",
        "code": "RK",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/RK@2x.png"
    },
    {
        "name": "Tigerair Taiwan",
        "code": "IT",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/IT@2x.png"
    },
    {
        "name": "Aerocaribbean",
        "code": "7L",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/7L@2x.png"
    },
    {
        "name": "Bearskin Airlines",
        "code": "JV",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/JV@2x.png"
    },
    {
        "name": "Aklak Air",
        "code": "6L",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/6L@2x.png"
    },
    {
        "name": "Allegiant Air",
        "code": "G4",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/G4@2x.png"
    },
    {
        "name": "Japan Air Commuter",
        "code": "JC",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/JC@2x.png"
    },
    {
        "name": "Jet Airways Inc.",
        "code": "QJ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/QJ@2x.png"
    },
    {
        "name": "Yamal Airlines",
        "code": "YC",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/YC@2x.png"
    },
    {
        "name": "TACV Cabo Verde Airlines",
        "code": "VR",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/VR@2x.png"
    },
    {
        "name": "Jatayu Airlines",
        "code": "JZ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/JZ@2x.png"
    },
    {
        "name": "Oriental Air Bridge",
        "code": "OC",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/OC@2x.png"
    },
    {
        "name": "ABX Air, Inc.",
        "code": "GB",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/GB@2x.png"
    },
    {
        "name": "Kuwait Airways",
        "code": "KU",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/KU@2x.png"
    },
    {
        "name": "Kunming Airlines",
        "code": "KY",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/KY@2x.png"
    },
    {
        "name": "Nordic Regional Airline",
        "code": "N7",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/N7@2x.png"
    },
    {
        "name": "Air Incheon",
        "code": "KJ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/KJ@2x.png"
    },
    {
        "name": "Cimber",
        "code": "QA",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/QA@2x.png"
    },
    {
        "name": "BADR AIRLINES",
        "code": "J4",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/J4@2x.png"
    },
    {
        "name": "Korean Air",
        "code": "KE",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/KE@2x.png"
    },
    {
        "name": "South Airlines",
        "code": "YG",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/YG@2x.png"
    },
    {
        "name": "Dniproavia",
        "code": "Z6",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/Z6@2x.png"
    },
    {
        "name": "FITS Air",
        "code": "8D",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/8D@2x.png"
    },
    {
        "name": "PT Kal Star Aviation",
        "code": "KD",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/KD@2x.png"
    },
    {
        "name": "BQB Lineas Aereas",
        "code": "5Q",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/5Q@2x.png"
    },
    {
        "name": "STP Airways",
        "code": "8F",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/8F@2x.png"
    },
    {
        "name": "Batik Air",
        "code": "OD",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/OD@2x.png"
    },
    {
        "name": "Hinterland Aviation",
        "code": "OI",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/OI@2x.png"
    },
    {
        "name": "Shenzhen Airlines",
        "code": "ZH",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/ZH@2x.png"
    },
    {
        "name": "Norwegian Air Shuttle",
        "code": "DY",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/DY@2x.png"
    },
    {
        "name": "Aero-Charter Ukraine",
        "code": "DW",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/DW@2x.png"
    },
    {
        "name": "Air Mandalay",
        "code": "6T",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/6T@2x.png"
    },
    {
        "name": "Cargojet Airways Ltd.",
        "code": "W8",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/W8@2x.png"
    },
    {
        "name": "Travelport Global Distribution SystemB.V.",
        "code": "1G",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/1G@2x.png"
    },
    {
        "name": "NYXAIR",
        "code": "OJ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/OJ@2x.png"
    },
    {
        "name": "IRYO",
        "code": "I6",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/I6@2x.png"
    },
    {
        "name": "Amaszonas",
        "code": "Z7",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/Z7@2x.png"
    },
    {
        "name": "Bees Airline",
        "code": "7B",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/7B@2x.png"
    },
    {
        "name": "Hebei Airlines",
        "code": "NS",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/NS@2x.png"
    },
    {
        "name": "Tajik Air",
        "code": "7J",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/7J@2x.png"
    },
    {
        "name": "Druk Air",
        "code": "KB",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/KB@2x.png"
    },
    {
        "name": "Luxair",
        "code": "LG",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/LG@2x.png"
    },
    {
        "name": "Maluti Sky",
        "code": "7D",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/7D@2x.png"
    },
    {
        "name": "Amaszonas",
        "code": "Z8",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/Z8@2x.png"
    },
    {
        "name": "UVT Aero",
        "code": "RT",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/RT@2x.png"
    },
    {
        "name": "Condor",
        "code": "DE",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/DE@2x.png"
    },
    {
        "name": "ITA Software Inc.",
        "code": "1U",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/1U@2x.png"
    },
    {
        "name": "China Airlines",
        "code": "CI",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/CI@2x.png"
    },
    {
        "name": "Alpine Aviation Inc.",
        "code": "5A",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/5A@2x.png"
    },
    {
        "name": "Kenn Borek Air Ltd.",
        "code": "4K",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/4K@2x.png"
    },
    {
        "name": "Himalaya Airlines",
        "code": "H9",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/H9@2x.png"
    },
    {
        "name": "NordStar",
        "code": "Y7",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/Y7@2x.png"
    },
    {
        "name": "SmartLynx Airlines",
        "code": "6Y",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/6Y@2x.png"
    },
    {
        "name": "Thomas Cook Airlines Belgium",
        "code": "HQ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/HQ@2x.png"
    },
    {
        "name": "Air Arabia Maroc",
        "code": "3O",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/3O@2x.png"
    },
    {
        "name": "Corendon Dutch Airlines",
        "code": "CD",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/CD@2x.png"
    },
    {
        "name": "Cityjet",
        "code": "WX",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/WX@2x.png"
    },
    {
        "name": "Trans-Mediterranean Airways",
        "code": "N2",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/N2@2x.png"
    },
    {
        "name": "Cyprus Airways",
        "code": "CY",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/CY@2x.png"
    },
    {
        "name": "GoJet Airlines",
        "code": "G7",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/G7@2x.png"
    },
    {
        "name": "Alitalia CityLiner",
        "code": "CT",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/CT@2x.png"
    },
    {
        "name": "Breeze Airways",
        "code": "MX",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/MX@2x.png"
    },
    {
        "name": "Flydubai",
        "code": "FZ",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/FZ@2x.png"
    },
    {
        "name": "Fly All Ways",
        "code": "8W",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/8W@2x.png"
    },
    {
        "name": "Air Transport International L.L.C.",
        "code": "8C",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/8C@2x.png"
    },
    {
        "name": "Air Niugini",
        "code": "PX",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/PX@2x.png"
    },
    {
        "name": "Atlantic Airways",
        "code": "RC",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/RC@2x.png"
    },
    {
        "name": "VIA Rail Canada Inc.",
        "code": "2R",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/2R@2x.png"
    },
    {
        "name": "AirConnect",
        "code": "KS",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/KS@2x.png"
    },
    {
        "name": "Air Ocean",
        "code": "0O",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/0O@2x.png"
    },
    {
        "name": "Webjet Linhas Aereas",
        "code": "WH",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/WH@2x.png"
    },
    {
        "name": "Chongqing Airlines",
        "code": "OQ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/OQ@2x.png"
    },
    {
        "name": "Air Anka",
        "code": "6K",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/6K@2x.png"
    },
    {
        "name": "Rutas Aereas, C.A. dba  RUTACA",
        "code": "5R",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/5R@2x.png"
    },
    {
        "name": "Precision Air",
        "code": "PW",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/PW@2x.png"
    },
    {
        "name": "Compagnie Africaine d'Aviation",
        "code": "BU",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/BU@2x.png"
    },
    {
        "name": "Akasa Air",
        "code": "QP",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/QP@2x.png"
    },
    {
        "name": "Vueling",
        "code": "VY",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/VY@2x.png"
    },
    {
        "name": "SATA Air Acores",
        "code": "SP",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/SP@2x.png"
    },
    {
        "name": "Sky Airlines",
        "code": "ZY",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/ZY@2x.png"
    },
    {
        "name": "CJSC Royal Flight airlines",
        "code": "4R",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/4R@2x.png"
    },
    {
        "name": "Sylt Air GmbH",
        "code": "7E",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/7E@2x.png"
    },
    {
        "name": "Cobham Aviation Services Australia",
        "code": "NC",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/NC@2x.png"
    },
    {
        "name": "Aruba Airlines",
        "code": "AG",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/AG@2x.png"
    },
    {
        "name": "Fly Branson Travel dba Branson AirExpress",
        "code": "1X",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/1X@2x.png"
    },
    {
        "name": "Jet Lite",
        "code": "S2",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/S2@2x.png"
    },
    {
        "name": "Malaysia Airlines",
        "code": "MH",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/MH@2x.png"
    },
    {
        "name": "Airnorth",
        "code": "TL",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/TL@2x.png"
    },
    {
        "name": "Axess International Network Inc.",
        "code": "1J",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/1J@2x.png"
    },
    {
        "name": "Air India",
        "code": "AI",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/AI@2x.png"
    },
    {
        "name": "La Compagnie",
        "code": "B0",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/B0@2x.png"
    },
    {
        "name": "Jet Airways",
        "code": "9W",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/9W@2x.png"
    },
    {
        "name": "Air Dolomiti",
        "code": "EN",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/EN@2x.png"
    },
    {
        "name": "Iliamna Air Taxi Inc.",
        "code": "V8",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/V8@2x.png"
    },
    {
        "name": "Korongo Airlines",
        "code": "ZC",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/ZC@2x.png"
    },
    {
        "name": "Ryanair",
        "code": "FR",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/FR@2x.png"
    },
    {
        "name": "Royal Brunei",
        "code": "BI",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/BI@2x.png"
    },
    {
        "name": "Mesa Airlines",
        "code": "YV",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/YV@2x.png"
    },
    {
        "name": "Moldavian Airlines",
        "code": "2M",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/2M@2x.png"
    },
    {
        "name": "Magnicharters",
        "code": "0Z",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/0Z@2x.png"
    },
    {
        "name": "Aeroflot",
        "code": "SU",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/SU@2x.png"
    },
    {
        "name": "Grumeti Air",
        "code": "0G",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/0G@2x.png"
    },
    {
        "name": "Garuda Indonesia",
        "code": "GA",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/GA@2x.png"
    },
    {
        "name": "KM Malta Airlines",
        "code": "KM",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/KM@2x.png"
    },
    {
        "name": "East Horizon Airlines",
        "code": "EA",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/EA@2x.png"
    },
    {
        "name": "Hahn Air",
        "code": "HR",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/HR@2x.png"
    },
    {
        "name": "Servicios A\u00e9reos de los Andes",
        "code": "FP",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/FP@2x.png"
    },
    {
        "name": "Urumqi Air",
        "code": "UQ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/UQ@2x.png"
    },
    {
        "name": "CM Airlines",
        "code": "H5",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/H5@2x.png"
    },
    {
        "name": "Lucky Air",
        "code": "8L",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/8L@2x.png"
    },
    {
        "name": "HiSky",
        "code": "H7",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/H7@2x.png"
    },
    {
        "name": "Executive Express Aviation LLC dbaSouthern Airways",
        "code": "9X",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/9X@2x.png"
    },
    {
        "name": "Avianca Cargo",
        "code": "QT",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/QT@2x.png"
    },
    {
        "name": "Air Mekong",
        "code": "P8",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/P8@2x.png"
    },
    {
        "name": "GetJet",
        "code": "GW",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/GW@2x.png"
    },
    {
        "name": "Caicos Express Airways",
        "code": "9Q",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/9Q@2x.png"
    },
    {
        "name": "Ruili Airlines",
        "code": "DR",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/DR@2x.png"
    },
    {
        "name": "Buraq Air Transport (BRQ)",
        "code": "UZ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/UZ@2x.png"
    },
    {
        "name": "As Avies",
        "code": "U3",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/U3@2x.png"
    },
    {
        "name": "Transavia Denmark",
        "code": "PH",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/PH@2x.png"
    },
    {
        "name": "fly2sky",
        "code": "F6",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/F6@2x.png"
    },
    {
        "name": "Sabre Pacific",
        "code": "1Z",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/1Z@2x.png"
    },
    {
        "name": "Iran Air",
        "code": "IR",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/IR@2x.png"
    },
    {
        "name": "Air Madagascar",
        "code": "MD",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/MD@2x.png"
    },
    {
        "name": "ExpressJet",
        "code": "XE",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/XE@2x.png"
    },
    {
        "name": "SkyWest Airlines",
        "code": "OO",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/OO@2x.png"
    },
    {
        "name": "Niki",
        "code": "HG",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/HG@2x.png"
    },
    {
        "name": "AccesRail",
        "code": "9B",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/9B@2x.png"
    },
    {
        "name": "Atlasjet Ukraine",
        "code": "UH",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/UH@2x.png"
    },
    {
        "name": "Chalair Aviation",
        "code": "CE",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/CE@2x.png"
    },
    {
        "name": "Wright Air Service",
        "code": "8V",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/8V@2x.png"
    },
    {
        "name": "SCAT",
        "code": "DV",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/DV@2x.png"
    },
    {
        "name": "Emetebe",
        "code": "0A",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/0A@2x.png"
    },
    {
        "name": "LOT Polish Airlines",
        "code": "LO",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/LO@2x.png"
    },
    {
        "name": "Corendon Airlines Europe",
        "code": "XR",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/XR@2x.png"
    },
    {
        "name": "Hydro - Quebec",
        "code": "0Q",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/0Q@2x.png"
    },
    {
        "name": "All Nippon Airways",
        "code": "NH",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/NH@2x.png"
    },
    {
        "name": "Nile Air",
        "code": "NP",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/NP@2x.png"
    },
    {
        "name": "Brussels Airlines",
        "code": "SN",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/SN@2x.png"
    },
    {
        "name": "Air Creebec",
        "code": "YN",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/YN@2x.png"
    },
    {
        "name": "Air Timor",
        "code": "6C",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/6C@2x.png"
    },
    {
        "name": "Blue Air",
        "code": "0B",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/0B@2x.png"
    },
    {
        "name": "Panorama Airways",
        "code": "5P",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/5P@2x.png"
    },
    {
        "name": "RwandAir",
        "code": "WB",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/WB@2x.png"
    },
    {
        "name": "Virgin Atlantic",
        "code": "VS",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/VS@2x.png"
    },
    {
        "name": "Tarco Air",
        "code": "3T",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/3T@2x.png"
    },
    {
        "name": "Cinnamon Air",
        "code": "C7",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/C7@2x.png"
    },
    {
        "name": "S7 Airlines",
        "code": "S7",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/S7@2x.png"
    },
    {
        "name": "Avianca Costa Rica",
        "code": "LR",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/LR@2x.png"
    },
    {
        "name": "DHL Air Limited",
        "code": "D0",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/D0@2x.png"
    },
    {
        "name": "Vistara",
        "code": "UK",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/UK@2x.png"
    },
    {
        "name": "Buzz",
        "code": "RR",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/RR@2x.png"
    },
    {
        "name": "Thai Express Air Co. Ltd",
        "code": "EX",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/EX@2x.png"
    },
    {
        "name": "Sabre Inc.",
        "code": "1S",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/1S@2x.png"
    },
    {
        "name": "ANA Wings",
        "code": "EH",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/EH@2x.png"
    },
    {
        "name": "Thomas Cook Airlines Scandinavia",
        "code": "DK",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/DK@2x.png"
    },
    {
        "name": "Aztec Airways",
        "code": "AJ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/AJ@2x.png"
    },
    {
        "name": "Global Aviation Services Group",
        "code": "5S",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/5S@2x.png"
    },
    {
        "name": "JETGO Australia",
        "code": "JG",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/JG@2x.png"
    },
    {
        "name": "South African Airways",
        "code": "SA",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/SA@2x.png"
    },
    {
        "name": "Nomad Aviation (PTY) Ltd.",
        "code": "N6",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/N6@2x.png"
    },
    {
        "name": "Travel Air",
        "code": "4P",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/4P@2x.png"
    },
    {
        "name": "Eastern Airways",
        "code": "T3",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/T3@2x.png"
    },
    {
        "name": "Aviateca",
        "code": "GU",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/GU@2x.png"
    },
    {
        "name": "Citilink Airlines",
        "code": "QG",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/QG@2x.png"
    },
    {
        "name": "Air Urga",
        "code": "3N",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/3N@2x.png"
    },
    {
        "name": "Calima Aviacion S.L",
        "code": "3C",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/3C@2x.png"
    },
    {
        "name": "LAN Chile Cargo",
        "code": "UC",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/UC@2x.png"
    },
    {
        "name": "Deutsche Bahn AG",
        "code": "2A",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/2A@2x.png"
    },
    {
        "name": "Continental Micronesia, Inc.",
        "code": "CS",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/CS@2x.png"
    },
    {
        "name": "Air Astana",
        "code": "KC",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/KC@2x.png"
    },
    {
        "name": "Clairmont Holdings Ltd dba VI Air Link",
        "code": "V6",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/V6@2x.png"
    },
    {
        "name": "Bird Information Systems Private Limited",
        "code": "1R",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/1R@2x.png"
    },
    {
        "name": "Passaredo Linhas Aereas",
        "code": "P3",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/P3@2x.png"
    },
    {
        "name": "People's Viennaline",
        "code": "PE",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/PE@2x.png"
    },
    {
        "name": "Elite Airways",
        "code": "7Q",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/7Q@2x.png"
    },
    {
        "name": "Travel Service",
        "code": "7O",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/7O@2x.png"
    },
    {
        "name": "Golden Myanmar Airlines Public Co., Ltd",
        "code": "Y5",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/Y5@2x.png"
    },
    {
        "name": "Thai AirAsia",
        "code": "FD",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/FD@2x.png"
    },
    {
        "name": "Kam Air",
        "code": "RQ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/RQ@2x.png"
    },
    {
        "name": "Skyway Costa Rica",
        "code": "LC",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/LC@2x.png"
    },
    {
        "name": "airBaltic",
        "code": "BT",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/BT@2x.png"
    },
    {
        "name": "Eastar Jet",
        "code": "ZE",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/ZE@2x.png"
    },
    {
        "name": "Horizon Air",
        "code": "QX",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/QX@2x.png"
    },
    {
        "name": "Safarilink Aviation",
        "code": "F2",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/F2@2x.png"
    },
    {
        "name": "Alaska Airlines",
        "code": "AS",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/AS@2x.png"
    },
    {
        "name": "Swiss International Air Lines",
        "code": "LX",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/LX@2x.png"
    },
    {
        "name": "Shirak Avia",
        "code": "5G",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/5G@2x.png"
    },
    {
        "name": "Nolinor Aviation",
        "code": "N5",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/N5@2x.png"
    },
    {
        "name": "Juneyao Airlines",
        "code": "HO",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/HO@2x.png"
    },
    {
        "name": "AirAsia",
        "code": "AK",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/AK@2x.png"
    },
    {
        "name": "Premier Trans Aire Inc.",
        "code": "3X",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/3X@2x.png"
    },
    {
        "name": "British Airways",
        "code": "BA",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/BA@2x.png"
    },
    {
        "name": "Alsa Grupo SLU",
        "code": "5I",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/5I@2x.png"
    },
    {
        "name": "9G Rail",
        "code": "9G",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/9G@2x.png"
    },
    {
        "name": "Premier Airlines",
        "code": "0M",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/0M@2x.png"
    },
    {
        "name": "EasyJet",
        "code": "U2",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/U2@2x.png"
    },
    {
        "name": "Tayaran Jet",
        "code": "E8",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/E8@2x.png"
    },
    {
        "name": "Skyward Express",
        "code": "OW",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/OW@2x.png"
    },
    {
        "name": "SATA",
        "code": "S4",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/S4@2x.png"
    },
    {
        "name": "Smartavia",
        "code": "5N",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/5N@2x.png"
    },
    {
        "name": "Amadeus IT Group SA",
        "code": "1A",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/1A@2x.png"
    },
    {
        "name": "Bermudair",
        "code": "2T",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/2T@2x.png"
    },
    {
        "name": "Air Georgian Ltd. dba Air Alliance",
        "code": "ZX",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/ZX@2x.png"
    },
    {
        "name": "T'way Air",
        "code": "TW",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/TW@2x.png"
    },
    {
        "name": "Aigle Azur",
        "code": "ZI",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/ZI@2x.png"
    },
    {
        "name": "Tus Airways",
        "code": "U8",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/U8@2x.png"
    },
    {
        "name": "S.C. Ten Airways S.R.L.",
        "code": "X5",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/X5@2x.png"
    },
    {
        "name": "AIR CAIRO",
        "code": "SM",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/SM@2x.png"
    },
    {
        "name": "FlyArna",
        "code": "G6",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/G6@2x.png"
    },
    {
        "name": "Braathens Regional",
        "code": "DC",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/DC@2x.png"
    },
    {
        "name": "Pakistan International Airlines",
        "code": "PK",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/PK@2x.png"
    },
    {
        "name": "Nova Airways",
        "code": "N9",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/N9@2x.png"
    },
    {
        "name": "Peruvian Airlines",
        "code": "P9",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/P9@2x.png"
    },
    {
        "name": "PT Republic Express Airlines",
        "code": "RH",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/RH@2x.png"
    },
    {
        "name": "AeroItalia",
        "code": "XZ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/XZ@2x.png"
    },
    {
        "name": "Regional Air Services",
        "code": "8N",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/8N@2x.png"
    },
    {
        "name": "NAM Air",
        "code": "IN",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/IN@2x.png"
    },
    {
        "name": "Interstate Airlines",
        "code": "I4",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/I4@2x.png"
    },
    {
        "name": "Skytrans",
        "code": "QN",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/QN@2x.png"
    },
    {
        "name": "Sol Lineas Aereas",
        "code": "8R",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/8R@2x.png"
    },
    {
        "name": "Sichuan Airlines",
        "code": "3U",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/3U@2x.png"
    },
    {
        "name": "Air Tahiti Nui",
        "code": "TN",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/TN@2x.png"
    },
    {
        "name": "LATAM Paraguay",
        "code": "PZ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/PZ@2x.png"
    },
    {
        "name": "Oman Air",
        "code": "WY",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/WY@2x.png"
    },
    {
        "name": "Pobeda",
        "code": "DP",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/DP@2x.png"
    },
    {
        "name": "Cathay Pacific",
        "code": "CX",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/CX@2x.png"
    },
    {
        "name": "Aerorepublica",
        "code": "P5",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/P5@2x.png"
    },
    {
        "name": "Taquan Air",
        "code": "K3",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/K3@2x.png"
    },
    {
        "name": "Air Italy",
        "code": "I9",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/I9@2x.png"
    },
    {
        "name": "AirExplore",
        "code": "ED",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/ED@2x.png"
    },
    {
        "name": "K-Mile Air Co. Ltd",
        "code": "8K",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/8K@2x.png"
    },
    {
        "name": "Belle Air",
        "code": "LZ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/LZ@2x.png"
    },
    {
        "name": "Air Saint Pierre",
        "code": "PJ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/PJ@2x.png"
    },
    {
        "name": "Pacific Coastal Airlines",
        "code": "8P",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/8P@2x.png"
    },
    {
        "name": "Jeju Air",
        "code": "7C",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/7C@2x.png"
    },
    {
        "name": "Sky Airline",
        "code": "H2",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/H2@2x.png"
    },
    {
        "name": "Donavia",
        "code": "D9",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/D9@2x.png"
    },
    {
        "name": "Jonair",
        "code": "0N",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/0N@2x.png"
    },
    {
        "name": "Air Manas",
        "code": "ZM",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/ZM@2x.png"
    },
    {
        "name": "PT. My Indo Airlines",
        "code": "2Y",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/2Y@2x.png"
    },
    {
        "name": "Air Albania",
        "code": "ZB",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/ZB@2x.png"
    },
    {
        "name": "Air Niamey",
        "code": "A7",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/A7@2x.png"
    },
    {
        "name": "Nordwind Airlines",
        "code": "N4",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/N4@2x.png"
    },
    {
        "name": "Bassaka Air Limited",
        "code": "5B",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/5B@2x.png"
    },
    {
        "name": "Gulf Air",
        "code": "GF",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/GF@2x.png"
    },
    {
        "name": "Helic\u00f3pteros del Sureste",
        "code": "UV",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/UV@2x.png"
    },
    {
        "name": "MAYAir",
        "code": "7M",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/7M@2x.png"
    },
    {
        "name": "FedEx",
        "code": "FX",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/FX@2x.png"
    },
    {
        "name": "HOP!",
        "code": "AN",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/AN@2x.png"
    },
    {
        "name": "Danish Air Transport",
        "code": "DX",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/DX@2x.png"
    },
    {
        "name": "Enter Air",
        "code": "E4",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/E4@2x.png"
    },
    {
        "name": "Wings of Lebanon S.a.l",
        "code": "W7",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/W7@2x.png"
    },
    {
        "name": "JSC Kazaviaspas",
        "code": "ZS",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/ZS@2x.png"
    },
    {
        "name": "Transaero Airlines",
        "code": "UN",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/UN@2x.png"
    },
    {
        "name": "Air Transport Association of Americad\\b\\a Airlines for America",
        "code": "XD",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/XD@2x.png"
    },
    {
        "name": "Utair",
        "code": "UT",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/UT@2x.png"
    },
    {
        "name": "Key Lime Air",
        "code": "KG",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/KG@2x.png"
    },
    {
        "name": "SeaPort Airlines",
        "code": "K5",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/K5@2x.png"
    },
    {
        "name": "Eurolot",
        "code": "K2",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/K2@2x.png"
    },
    {
        "name": "Aerol\u00edneas Sosa",
        "code": "P4",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/P4@2x.png"
    },
    {
        "name": "Vanilla Air",
        "code": "JW",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/JW@2x.png"
    },
    {
        "name": "Anguilla Air",
        "code": "Q3",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/Q3@2x.png"
    },
    {
        "name": "JetSMART",
        "code": "WJ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/WJ@2x.png"
    },
    {
        "name": "Bulgarian Air Charter",
        "code": "H6",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/H6@2x.png"
    },
    {
        "name": "Kartika Airlines",
        "code": "3Y",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/3Y@2x.png"
    },
    {
        "name": "Nippon Cargo Airlines",
        "code": "KZ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/KZ@2x.png"
    },
    {
        "name": "SkyWork Airlines",
        "code": "SX",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/SX@2x.png"
    },
    {
        "name": "African Express Airways (K)  Limited",
        "code": "XU",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/XU@2x.png"
    },
    {
        "name": "Aero Contractors",
        "code": "NG",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/NG@2x.png"
    },
    {
        "name": "EcoJet",
        "code": "8J",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/8J@2x.png"
    },
    {
        "name": "Coastal Travels",
        "code": "CQ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/CQ@2x.png"
    },
    {
        "name": "Alexandria Airlines",
        "code": "DQ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/DQ@2x.png"
    },
    {
        "name": "Lufthansa City",
        "code": "VL",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/VL@2x.png"
    },
    {
        "name": "Camair-Co",
        "code": "QC",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/QC@2x.png"
    },
    {
        "name": "Tunisair Express",
        "code": "UG",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/UG@2x.png"
    },
    {
        "name": "Afrinat International Airlines",
        "code": "2F",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/2F@2x.png"
    },
    {
        "name": "Cobalt Air",
        "code": "CO",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/CO@2x.png"
    },
    {
        "name": "IATA - Clearing HouseInternational Air Transport Association",
        "code": "XB",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/XB@2x.png"
    },
    {
        "name": "LAN COLOMBIA AIRLINES",
        "code": "4C",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/4C@2x.png"
    },
    {
        "name": "Yemenia",
        "code": "IY",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/IY@2x.png"
    },
    {
        "name": "ZanAir",
        "code": "B4",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/B4@2x.png"
    },
    {
        "name": "IBC Airways",
        "code": "II",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/II@2x.png"
    },
    {
        "name": "TAME Linea Aerea del Ecuador",
        "code": "EQ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/EQ@2x.png"
    },
    {
        "name": "Singapore Airlines",
        "code": "SQ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/SQ@2x.png"
    },
    {
        "name": "TNT Airways",
        "code": "3V",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/3V@2x.png"
    },
    {
        "name": "Syrian Arab Airlines",
        "code": "RB",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/RB@2x.png"
    },
    {
        "name": "IndiGo",
        "code": "6E",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/6E@2x.png"
    },
    {
        "name": "Finnair",
        "code": "AY",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/AY@2x.png"
    },
    {
        "name": "Daallo Airlines",
        "code": "D3",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/D3@2x.png"
    },
    {
        "name": "Eurostar",
        "code": "9F",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/9F@2x.png"
    },
    {
        "name": "Twin Jet",
        "code": "T7",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/T7@2x.png"
    },
    {
        "name": "Afriqiyah Airways",
        "code": "8U",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/8U@2x.png"
    },
    {
        "name": "Swoop",
        "code": "WO",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/WO@2x.png"
    },
    {
        "name": "AirAsia X",
        "code": "D7",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/D7@2x.png"
    },
    {
        "name": "Kenmore Air",
        "code": "M5",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/M5@2x.png"
    },
    {
        "name": "RusLine",
        "code": "7R",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/7R@2x.png"
    },
    {
        "name": "Volaris",
        "code": "Y4",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/Y4@2x.png"
    },
    {
        "name": "Lion Air",
        "code": "JT",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/JT@2x.png"
    },
    {
        "name": "Armenian Airlines",
        "code": "JI",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/JI@2x.png"
    },
    {
        "name": "Iberia Express",
        "code": "I2",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/I2@2x.png"
    },
    {
        "name": "Vision Airlines",
        "code": "V2",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/V2@2x.png"
    },
    {
        "name": "Royal Jordanian",
        "code": "RJ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/RJ@2x.png"
    },
    {
        "name": "Ural Airlines",
        "code": "U6",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/U6@2x.png"
    },
    {
        "name": "EasyJet Europe",
        "code": "EC",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/EC@2x.png"
    },
    {
        "name": "Jambojet",
        "code": "JM",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/JM@2x.png"
    },
    {
        "name": "Cebu Pacific",
        "code": "5J",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/5J@2x.png"
    },
    {
        "name": "ATA Airlines",
        "code": "I3",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/I3@2x.png"
    },
    {
        "name": "Chengdu Airlines",
        "code": "EU",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/EU@2x.png"
    },
    {
        "name": "40-Mile Air",
        "code": "Q5",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/Q5@2x.png"
    },
    {
        "name": "Northwest Airlines",
        "code": "NW",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/NW@2x.png"
    },
    {
        "name": "Czech Airlines",
        "code": "OK",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/OK@2x.png"
    },
    {
        "name": "Carpatair",
        "code": "V3",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/V3@2x.png"
    },
    {
        "name": "Transavia",
        "code": "TO",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/TO@2x.png"
    },
    {
        "name": "Jazeera Airways",
        "code": "J9",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/J9@2x.png"
    },
    {
        "name": "Pascan Aviation",
        "code": "P6",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/P6@2x.png"
    },
    {
        "name": "Proflight Zambia",
        "code": "P0",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/P0@2x.png"
    },
    {
        "name": "Hong Kong Airlines",
        "code": "HX",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/HX@2x.png"
    },
    {
        "name": "Inter Air",
        "code": "D6",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/D6@2x.png"
    },
    {
        "name": "Berjaya Air",
        "code": "J8",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/J8@2x.png"
    },
    {
        "name": "Mann Yadanarpon Airlines",
        "code": "7Y",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/7Y@2x.png"
    },
    {
        "name": "SNCF",
        "code": "2C",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/2C@2x.png"
    },
    {
        "name": "Aviair",
        "code": "GD",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/GD@2x.png"
    },
    {
        "name": "Thomas Cook Airlines",
        "code": "MT",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/MT@2x.png"
    },
    {
        "name": "GlobeAir",
        "code": "0K",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/0K@2x.png"
    },
    {
        "name": "Zacarias Moreno",
        "code": "6M",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/6M@2x.png"
    },
    {
        "name": "Indonesia AirAsia",
        "code": "QZ",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/QZ@2x.png"
    },
    {
        "name": "SITA - Airlines WorldwideTelecommunications and Information Svcs",
        "code": "XS",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/XS@2x.png"
    },
    {
        "name": "Finistair",
        "code": "0D",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/0D@2x.png"
    },
    {
        "name": "US-Bangla Airlines",
        "code": "BS",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/BS@2x.png"
    },
    {
        "name": "Sansa Airlines",
        "code": "RZ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/RZ@2x.png"
    },
    {
        "name": "AVANZA",
        "code": "6V",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/6V@2x.png"
    },
    {
        "name": "Star Peru",
        "code": "2I",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/2I@2x.png"
    },
    {
        "name": "Central Mountain Air",
        "code": "9M",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/9M@2x.png"
    },
    {
        "name": "Hahn Air Technologies",
        "code": "X1",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/X1@2x.png"
    },
    {
        "name": "Somon Air",
        "code": "SZ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/SZ@2x.png"
    },
    {
        "name": "Myanmar National Airlines",
        "code": "UB",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/UB@2x.png"
    },
    {
        "name": "ULS Airlines Cargo",
        "code": "GO",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/GO@2x.png"
    },
    {
        "name": "FlyArystan",
        "code": "FS",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/FS@2x.png"
    },
    {
        "name": "Itek Air",
        "code": "GI",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/GI@2x.png"
    },
    {
        "name": "ExpressJet",
        "code": "EV",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/EV@2x.png"
    },
    {
        "name": "Jet Express",
        "code": "G2",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/G2@2x.png"
    },
    {
        "name": "Eurowings",
        "code": "EW",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/EW@2x.png"
    },
    {
        "name": "Pan American World Airways",
        "code": "7N",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/7N@2x.png"
    },
    {
        "name": "KLM Cityhopper",
        "code": "WA",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/WA@2x.png"
    },
    {
        "name": "Africa World Airlines",
        "code": "AW",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/AW@2x.png"
    },
    {
        "name": "Maya Island Air",
        "code": "MY",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/MY@2x.png"
    },
    {
        "name": "Speed train",
        "code": "0U",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/0U@2x.png"
    },
    {
        "name": "Delta Air Lines",
        "code": "DL",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/DL@2x.png"
    },
    {
        "name": "Tbilisi Airways",
        "code": "TD",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/TD@2x.png"
    },
    {
        "name": "Eritrean Airlines",
        "code": "B8",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/B8@2x.png"
    },
    {
        "name": "Aircalin",
        "code": "SB",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/SB@2x.png"
    },
    {
        "name": "BH Air",
        "code": "8H",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/8H@2x.png"
    },
    {
        "name": "Peach",
        "code": "MM",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/MM@2x.png"
    },
    {
        "name": "Passaredo Transportes Aereos S.A.",
        "code": "2Z",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/2Z@2x.png"
    },
    {
        "name": "Cayman Airways",
        "code": "KX",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/KX@2x.png"
    },
    {
        "name": "A.P.G. Distribution System",
        "code": "A1",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/A1@2x.png"
    },
    {
        "name": "Red Wings",
        "code": "WZ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/WZ@2x.png"
    },
    {
        "name": "Safi Airways",
        "code": "4Q",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/4Q@2x.png"
    },
    {
        "name": "Hi Fly Ltd",
        "code": "5M",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/5M@2x.png"
    },
    {
        "name": "Virgin Australia",
        "code": "VA",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/VA@2x.png"
    },
    {
        "name": "Thai Airways",
        "code": "TG",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/TG@2x.png"
    },
    {
        "name": "Silk Way Airlines",
        "code": "ZP",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/ZP@2x.png"
    },
    {
        "name": "TACA Peru",
        "code": "T0",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/T0@2x.png"
    },
    {
        "name": "Heli Air Monaco",
        "code": "YO",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/YO@2x.png"
    },
    {
        "name": "Olympic Air",
        "code": "OA",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/OA@2x.png"
    },
    {
        "name": "Iran Airtour",
        "code": "B9",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/B9@2x.png"
    },
    {
        "name": "Silver Airways",
        "code": "3M",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/3M@2x.png"
    },
    {
        "name": "Air Cargo Carriers, LLC.",
        "code": "2Q",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/2Q@2x.png"
    },
    {
        "name": "National Airlines",
        "code": "N8",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/N8@2x.png"
    },
    {
        "name": "Westjet",
        "code": "WS",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/WS@2x.png"
    },
    {
        "name": "Up Israel",
        "code": "86",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/86@2x.png"
    },
    {
        "name": "Pegasus Airlines",
        "code": "PC",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/PC@2x.png"
    },
    {
        "name": "Galileo International",
        "code": "1V",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/1V@2x.png"
    },
    {
        "name": "ALS Ltd.",
        "code": "K4",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/K4@2x.png"
    },
    {
        "name": "Angara Airlines",
        "code": "2G",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/2G@2x.png"
    },
    {
        "name": "Tassili Airlines",
        "code": "SF",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/SF@2x.png"
    },
    {
        "name": "Myanmar Airways International",
        "code": "8M",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/8M@2x.png"
    },
    {
        "name": "World Ticket Ltd",
        "code": "W1",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/W1@2x.png"
    },
    {
        "name": "Equaflight Service",
        "code": "E7",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/E7@2x.png"
    },
    {
        "name": "Centrum Air",
        "code": "C6",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/C6@2x.png"
    },
    {
        "name": "Virgin America ",
        "code": "VX",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/VX@2x.png"
    },
    {
        "name": "Uni Air",
        "code": "B7",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/B7@2x.png"
    },
    {
        "name": "BRA",
        "code": "TF",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/TF@2x.png"
    },
    {
        "name": "Air Vanuatu",
        "code": "NF",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/NF@2x.png"
    },
    {
        "name": "Southwest Airlines",
        "code": "WN",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/WN@2x.png"
    },
    {
        "name": "KLM",
        "code": "KL",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/KL@2x.png"
    },
    {
        "name": "Belavia",
        "code": "B2",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/B2@2x.png"
    },
    {
        "name": "French Armed Forces",
        "code": "RD",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/RD@2x.png"
    },
    {
        "name": "Bulgaria Air",
        "code": "FB",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/FB@2x.png"
    },
    {
        "name": "JetSMART",
        "code": "JA",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/JA@2x.png"
    },
    {
        "name": "Air Inuit",
        "code": "3H",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/3H@2x.png"
    },
    {
        "name": "Fly CamInter",
        "code": "EF",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/EF@2x.png"
    },
    {
        "name": "Southern Sky",
        "code": "IH",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/IH@2x.png"
    },
    {
        "name": "Norse Atlantic Airways",
        "code": "N0",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/N0@2x.png"
    },
    {
        "name": "VIM Airlines",
        "code": "NN",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/NN@2x.png"
    },
    {
        "name": "European Air Transport",
        "code": "QY",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/QY@2x.png"
    },
    {
        "name": "Air Sinai",
        "code": "4D",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/4D@2x.png"
    },
    {
        "name": "SunExpress Deutschland",
        "code": "XG",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/XG@2x.png"
    },
    {
        "name": "Air Caraibes",
        "code": "TX",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/TX@2x.png"
    },
    {
        "name": "Special Ground Handling Service -XH",
        "code": "XH",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/XH@2x.png"
    },
    {
        "name": "Lift",
        "code": "GE",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/GE@2x.png"
    },
    {
        "name": "Aero Transporte S.A.",
        "code": "4A",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/4A@2x.png"
    },
    {
        "name": "Aero Nomad Airlines",
        "code": "KA",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/KA@2x.png"
    },
    {
        "name": "CitizenPlane",
        "code": "1L",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/1L@2x.png"
    },
    {
        "name": "PM Air LLC",
        "code": "Z3",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/Z3@2x.png"
    },
    {
        "name": "Air Atlanta",
        "code": "CC",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/CC@2x.png"
    },
    {
        "name": "Bemidji Airlines",
        "code": "CH",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/CH@2x.png"
    },
    {
        "name": "PT Aerosystems Indonesia",
        "code": "1T",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/1T@2x.png"
    },
    {
        "name": "World2Fly",
        "code": "2W",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/2W@2x.png"
    },
    {
        "name": "Sunrise Airways",
        "code": "S6",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/S6@2x.png"
    },
    {
        "name": "Aerolitoral S.A. de C.V.",
        "code": "5D",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/5D@2x.png"
    },
    {
        "name": "Northwestern Air",
        "code": "J3",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/J3@2x.png"
    },
    {
        "name": "Laudamotion",
        "code": "OE",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/OE@2x.png"
    },
    {
        "name": "Vista Georgia",
        "code": "GT",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/GT@2x.png"
    },
    {
        "name": "LATAM Chile",
        "code": "LA",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/LA@2x.png"
    },
    {
        "name": "Orient Thai Airlines",
        "code": "OX",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/OX@2x.png"
    },
    {
        "name": "TRIP Linhas A\u00e9reas",
        "code": "T4",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/T4@2x.png"
    },
    {
        "name": "Manx2",
        "code": "NM",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/NM@2x.png"
    },
    {
        "name": "Aerol\u00edneas Mas",
        "code": "N3",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/N3@2x.png"
    },
    {
        "name": "Jetlink Express",
        "code": "J0",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/J0@2x.png"
    },
    {
        "name": "Croatia Airlines",
        "code": "OU",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/OU@2x.png"
    },
    {
        "name": "American Eagle",
        "code": "ZZ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/ZZ@2x.png"
    },
    {
        "name": "Beijing Capital Airlines",
        "code": "JD",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/JD@2x.png"
    },
    {
        "name": "Afghan Jet International",
        "code": "HN",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/HN@2x.png"
    },
    {
        "name": "Cronos Airlines",
        "code": "C8",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/C8@2x.png"
    },
    {
        "name": "Premium Jet AG",
        "code": "0J",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/0J@2x.png"
    },
    {
        "name": "Zagros Airlines",
        "code": "ZV",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/ZV@2x.png"
    },
    {
        "name": "Flybe",
        "code": "BE",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/BE@2x.png"
    },
    {
        "name": "Ryan Air Service",
        "code": "7S",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/7S@2x.png"
    },
    {
        "name": "Aero Mongolia",
        "code": "M0",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/M0@2x.png"
    },
    {
        "name": "Smokey Bay Air, Inc.",
        "code": "2E",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/2E@2x.png"
    },
    {
        "name": "Globus LL\u0421",
        "code": "XT",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/XT@2x.png"
    },
    {
        "name": "JSC Aircompany ATMA",
        "code": "IM",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/IM@2x.png"
    },
    {
        "name": "Jetstar Pacific Airlines",
        "code": "BL",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/BL@2x.png"
    },
    {
        "name": "Sun d'Or International Airlines",
        "code": "2U",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/2U@2x.png"
    },
    {
        "name": "Island Air",
        "code": "WP",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/WP@2x.png"
    },
    {
        "name": "Aegean Airlines",
        "code": "A3",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/A3@2x.png"
    },
    {
        "name": "Dobrolet",
        "code": "QD",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/QD@2x.png"
    },
    {
        "name": "Grand Canyon Airlines, Inc.dba Scenic Airlines",
        "code": "YR",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/YR@2x.png"
    },
    {
        "name": "Lumiwings",
        "code": "L9",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/L9@2x.png"
    },
    {
        "name": "Icelandair",
        "code": "FI",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/FI@2x.png"
    },
    {
        "name": "Air Canada",
        "code": "AC",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/AC@2x.png"
    },
    {
        "name": "STARLUX AIRLINES",
        "code": "JX",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/JX@2x.png"
    },
    {
        "name": "Gazpromavia",
        "code": "4G",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/4G@2x.png"
    },
    {
        "name": "C.A.I. Second",
        "code": "VE",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/VE@2x.png"
    },
    {
        "name": "VietjetAir",
        "code": "VJ",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/VJ@2x.png"
    },
    {
        "name": "Tiara Air Aruba",
        "code": "3P",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/3P@2x.png"
    },
    {
        "name": "UR Airline",
        "code": "UD",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/UD@2x.png"
    },
    {
        "name": "Atlas Air",
        "code": "5Y",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/5Y@2x.png"
    },
    {
        "name": "Orbest",
        "code": "6O",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/6O@2x.png"
    },
    {
        "name": "Surinam Airways",
        "code": "PY",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/PY@2x.png"
    },
    {
        "name": "Air Panama",
        "code": "7P",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/7P@2x.png"
    },
    {
        "name": "Israir Airlines",
        "code": "6H",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/6H@2x.png"
    },
    {
        "name": "Emirates",
        "code": "EK",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/EK@2x.png"
    },
    {
        "name": "Alaska Seaplane",
        "code": "J5",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/J5@2x.png"
    },
    {
        "name": "Southern Air Charter",
        "code": "PL",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/PL@2x.png"
    },
    {
        "name": "China West Air",
        "code": "PN",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/PN@2x.png"
    },
    {
        "name": "Mavi Gok Airlines",
        "code": "4M",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/4M@2x.png"
    },
    {
        "name": "Fly Lili",
        "code": "FL",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/FL@2x.png"
    },
    {
        "name": "TUIfly Nordic",
        "code": "6B",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/6B@2x.png"
    },
    {
        "name": "Humo Air",
        "code": "HJ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/HJ@2x.png"
    },
    {
        "name": "Aero-Tropics Air Services",
        "code": "HC",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/HC@2x.png"
    },
    {
        "name": "Air Montenegro",
        "code": "YM",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/YM@2x.png"
    },
    {
        "name": "Cape Air",
        "code": "9K",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/9K@2x.png"
    },
    {
        "name": "Copa Airlines",
        "code": "CM",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/CM@2x.png"
    },
    {
        "name": "Papillon Airways",
        "code": "HI",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/HI@2x.png"
    },
    {
        "name": "Exec Air, Inc. of Naples",
        "code": "X7",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/X7@2x.png"
    },
    {
        "name": "Aurora",
        "code": "HZ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/HZ@2x.png"
    },
    {
        "name": "JetAir Caribbean",
        "code": "4J",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/4J@2x.png"
    },
    {
        "name": "Sky Express",
        "code": "GQ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/GQ@2x.png"
    },
    {
        "name": "LATAM Ecuador",
        "code": "XL",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/XL@2x.png"
    },
    {
        "name": "Iran Aseman Airlines",
        "code": "EP",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/EP@2x.png"
    },
    {
        "name": "Abacus International Pte. Ltd.",
        "code": "1B",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/1B@2x.png"
    },
    {
        "name": "Cambodia Angkor Air",
        "code": "K6",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/K6@2x.png"
    },
    {
        "name": "Lao Skyway",
        "code": "LK",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/LK@2x.png"
    },
    {
        "name": "Royal Air Maroc",
        "code": "AT",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/AT@2x.png"
    },
    {
        "name": "Etihad Airways",
        "code": "EY",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/EY@2x.png"
    },
    {
        "name": "Air New Zealand",
        "code": "NZ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/NZ@2x.png"
    },
    {
        "name": "ARINC(Aeronautical Radio, Inc.)",
        "code": "XA",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/XA@2x.png"
    },
    {
        "name": "Wamos Air",
        "code": "EB",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/EB@2x.png"
    },
    {
        "name": "Nauru Airline",
        "code": "ON",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/ON@2x.png"
    },
    {
        "name": "Jiangxi Air",
        "code": "RY",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/RY@2x.png"
    },
    {
        "name": "Flybondi",
        "code": "FO",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/FO@2x.png"
    },
    {
        "name": "Toki Air",
        "code": "BV",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/BV@2x.png"
    },
    {
        "name": "Spring Airlines Japan",
        "code": "IJ",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/IJ@2x.png"
    },
    {
        "name": "Regional Jet O\u00dc",
        "code": "EE",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/EE@2x.png"
    },
    {
        "name": "Douniah Airlines",
        "code": "DH",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/DH@2x.png"
    },
    {
        "name": "Air Wisconsin Airlines Corporation(AWAC)",
        "code": "ZW",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/ZW@2x.png"
    },
    {
        "name": "Heron Aviation",
        "code": "0V",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/0V@2x.png"
    },
    {
        "name": "Eurostar",
        "code": "2H",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/2H@2x.png"
    },
    {
        "name": "Winair",
        "code": "WM",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/WM@2x.png"
    },
    {
        "name": "Starbow",
        "code": "S9",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/S9@2x.png"
    },
    {
        "name": "Merpati Nusantara Airlines",
        "code": "MZ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/MZ@2x.png"
    },
    {
        "name": "Azul Brazilian Airlines",
        "code": "AD",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/AD@2x.png"
    },
    {
        "name": "Bangkok Airways",
        "code": "PG",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/PG@2x.png"
    },
    {
        "name": "First Air",
        "code": "7F",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/7F@2x.png"
    },
    {
        "name": "Amerijet International Inc.",
        "code": "M6",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/M6@2x.png"
    },
    {
        "name": "Farelogix Qatar Airways",
        "code": "F1",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/F1@2x.png"
    },
    {
        "name": "Videcom International Limited",
        "code": "U1",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/U1@2x.png"
    },
    {
        "name": "Wizz Air",
        "code": "5W",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/5W@2x.png"
    },
    {
        "name": "BMI Regional",
        "code": "BM",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/BM@2x.png"
    },
    {
        "name": "Japan Transocean Air",
        "code": "NU",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/NU@2x.png"
    },
    {
        "name": "Avior Airlines",
        "code": "3R",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/3R@2x.png"
    },
    {
        "name": "C.A.I. First",
        "code": "XM",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/XM@2x.png"
    },
    {
        "name": "Worldspan",
        "code": "1P",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/1P@2x.png"
    },
    {
        "name": "Zambezi Airlines",
        "code": "ZJ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/ZJ@2x.png"
    },
    {
        "name": "Jetstar",
        "code": "JQ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/JQ@2x.png"
    },
    {
        "name": "Thomson Airways",
        "code": "BY",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/BY@2x.png"
    },
    {
        "name": "Wizz Air",
        "code": "W4",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/W4@2x.png"
    },
    {
        "name": "Asiana Airlines",
        "code": "OZ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/OZ@2x.png"
    },
    {
        "name": "Sunwing Airlines",
        "code": "WG",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/WG@2x.png"
    },
    {
        "name": "Thai Vietjet Air",
        "code": "VZ",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/VZ@2x.png"
    },
    {
        "name": "Kenya Airways",
        "code": "KQ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/KQ@2x.png"
    },
    {
        "name": "Luxwing",
        "code": "BN",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/BN@2x.png"
    },
    {
        "name": "Pegas Fly",
        "code": "EO",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/EO@2x.png"
    },
    {
        "name": "Lodyssey",
        "code": "0L",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/0L@2x.png"
    },
    {
        "name": "Linear Air",
        "code": "O2",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/O2@2x.png"
    },
    {
        "name": "Air Busan",
        "code": "BX",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/BX@2x.png"
    },
    {
        "name": "Hunnu Air",
        "code": "MR",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/MR@2x.png"
    },
    {
        "name": "Sun-Air of Scandinavia",
        "code": "EZ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/EZ@2x.png"
    },
    {
        "name": "Department of National Defence",
        "code": "YF",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/YF@2x.png"
    },
    {
        "name": "Chang An Airlines",
        "code": "9H",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/9H@2x.png"
    },
    {
        "name": "Georgian Wings",
        "code": "D4",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/D4@2x.png"
    },
    {
        "name": "Canaryfly",
        "code": "PM",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/PM@2x.png"
    },
    {
        "name": "UM Airlines",
        "code": "UF",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/UF@2x.png"
    },
    {
        "name": "Stabo Air Limited",
        "code": "4E",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/4E@2x.png"
    },
    {
        "name": "Air Tanzania",
        "code": "TC",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/TC@2x.png"
    },
    {
        "name": "Karinou Airlines",
        "code": "U5",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/U5@2x.png"
    },
    {
        "name": "China Express Airlines",
        "code": "G5",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/G5@2x.png"
    },
    {
        "name": "Yangtze River Express",
        "code": "Y8",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/Y8@2x.png"
    },
    {
        "name": "JSC \"Sirena-Travel\"",
        "code": "1H",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/1H@2x.png"
    },
    {
        "name": "Grant Aviation, Inc.",
        "code": "GV",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/GV@2x.png"
    },
    {
        "name": "JetBlue Airways",
        "code": "B6",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/B6@2x.png"
    },
    {
        "name": "Air Austral",
        "code": "UU",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/UU@2x.png"
    },
    {
        "name": "Air East",
        "code": "ER",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/ER@2x.png"
    },
    {
        "name": "Sky-Taxi",
        "code": "TE",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/TE@2x.png"
    },
    {
        "name": "Endeavor Air",
        "code": "9E",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/9E@2x.png"
    },
    {
        "name": "RUS Aviation",
        "code": "R4",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/R4@2x.png"
    },
    {
        "name": "ASKY Airlines",
        "code": "KP",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/KP@2x.png"
    },
    {
        "name": "Iberia",
        "code": "IB",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/IB@2x.png"
    },
    {
        "name": "Dana Airlines Limited",
        "code": "9J",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/9J@2x.png"
    },
    {
        "name": "Stobart Air",
        "code": "RE",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/RE@2x.png"
    },
    {
        "name": "Grand China Air",
        "code": "CN",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/CN@2x.png"
    },
    {
        "name": "Frontier Airlines",
        "code": "F9",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/F9@2x.png"
    },
    {
        "name": "Link Airways",
        "code": "FC",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/FC@2x.png"
    },
    {
        "name": "Air Europa",
        "code": "UX",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/UX@2x.png"
    },
    {
        "name": "Joon",
        "code": "JN",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/JN@2x.png"
    },
    {
        "name": "ASL Airlines France",
        "code": "5O",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/5O@2x.png"
    },
    {
        "name": "Mokulele Airlines",
        "code": "MW",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/MW@2x.png"
    },
    {
        "name": "Air Montenegro",
        "code": "4O",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/4O@2x.png"
    },
    {
        "name": "Brit Air",
        "code": "DB",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/DB@2x.png"
    },
    {
        "name": "NokScoot",
        "code": "XW",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/XW@2x.png"
    },
    {
        "name": "Air Moldova",
        "code": "9U",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/9U@2x.png"
    },
    {
        "name": "Level",
        "code": "LV",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/LV@2x.png"
    },
    {
        "name": "LEAV",
        "code": "KK",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/KK@2x.png"
    },
    {
        "name": "Bul Air",
        "code": "LB",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/LB@2x.png"
    },
    {
        "name": "North Flying",
        "code": "M3",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/M3@2x.png"
    },
    {
        "name": "Sriwijaya Air",
        "code": "SJ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/SJ@2x.png"
    },
    {
        "name": "Empire Airlines",
        "code": "EM",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/EM@2x.png"
    },
    {
        "name": "CEIBA Intercontinental",
        "code": "C2",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/C2@2x.png"
    },
    {
        "name": "Air China",
        "code": "CA",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/CA@2x.png"
    },
    {
        "name": "Scandinavian Airlines",
        "code": "SK",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/SK@2x.png"
    },
    {
        "name": "IBS Software Services Americas, Inc.",
        "code": "V1",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/V1@2x.png"
    },
    {
        "name": "Gambia Bird Airlines",
        "code": "3G",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/3G@2x.png"
    },
    {
        "name": "Batik Air Indonesia",
        "code": "ID",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/ID@2x.png"
    },
    {
        "name": "DHL Aero Expreso S.A.",
        "code": "D5",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/D5@2x.png"
    },
    {
        "name": "Travel Technology Interactive SA",
        "code": "Y1",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/Y1@2x.png"
    },
    {
        "name": "Tarom",
        "code": "RO",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/RO@2x.png"
    },
    {
        "name": "Bhutan Airlines",
        "code": "B3",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/B3@2x.png"
    },
    {
        "name": "Major Airline",
        "code": "YY",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/YY@2x.png"
    },
    {
        "name": "Airmax S.A.",
        "code": "X8",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/X8@2x.png"
    },
    {
        "name": "Motor Sich Airlines",
        "code": "M9",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/M9@2x.png"
    },
    {
        "name": "Solaseed Air",
        "code": "6J",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/6J@2x.png"
    },
    {
        "name": "Travelsky Technology Limited",
        "code": "1E",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/1E@2x.png"
    },
    {
        "name": "Ak Bars Aero",
        "code": "2B",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/2B@2x.png"
    },
    {
        "name": "ITA Airways",
        "code": "AZ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/AZ@2x.png"
    },
    {
        "name": "Firefly",
        "code": "FY",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/FY@2x.png"
    },
    {
        "name": "Air Alps Aviation",
        "code": "A6",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/A6@2x.png"
    },
    {
        "name": "Neos",
        "code": "NO",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/NO@2x.png"
    },
    {
        "name": "Orange Air, LLCN/A",
        "code": "O3",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/O3@2x.png"
    },
    {
        "name": "Uganda Airlines",
        "code": "UR",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/UR@2x.png"
    },
    {
        "name": "SkyBahamas Airlines",
        "code": "Q7",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/Q7@2x.png"
    },
    {
        "name": "AIS Airlines",
        "code": "0C",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/0C@2x.png"
    },
    {
        "name": "Edelweiss Air",
        "code": "WK",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/WK@2x.png"
    },
    {
        "name": "Wizz Air",
        "code": "W6",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/W6@2x.png"
    },
    {
        "name": "Avia Traffic Company",
        "code": "YK",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/YK@2x.png"
    },
    {
        "name": "Air Mobility Command",
        "code": "MC",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/MC@2x.png"
    },
    {
        "name": "PT.Trigana Air Service",
        "code": "IL",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/IL@2x.png"
    },
    {
        "name": "Aerolink Uganda Limited",
        "code": "A8",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/A8@2x.png"
    },
    {
        "name": "Vieques Air Link",
        "code": "V4",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/V4@2x.png"
    },
    {
        "name": "Zagros Air Co.",
        "code": "Z4",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/Z4@2x.png"
    },
    {
        "name": "Azerbaijan Airlines",
        "code": "J2",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/J2@2x.png"
    },
    {
        "name": "MIAT Mongolian Airlines",
        "code": "OM",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/OM@2x.png"
    },
    {
        "name": "MyWay Airlines",
        "code": "MJ",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/MJ@2x.png"
    },
    {
        "name": "Turkmenistan Airlines",
        "code": "T5",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/T5@2x.png"
    },
    {
        "name": "Ernest Airline",
        "code": "EG",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/EG@2x.png"
    },
    {
        "name": "Yan Air Ltd",
        "code": "YE",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/YE@2x.png"
    },
    {
        "name": "Jetstar Asia",
        "code": "3K",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/3K@2x.png"
    },
    {
        "name": "Globus Airlines",
        "code": "GH",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/GH@2x.png"
    },
    {
        "name": "Provincial Airlines",
        "code": "PB",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/PB@2x.png"
    },
    {
        "name": "TezJet",
        "code": "K9",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/K9@2x.png"
    },
    {
        "name": "Airkenya Express",
        "code": "P2",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/P2@2x.png"
    },
    {
        "name": "Regional Express",
        "code": "ZL",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/ZL@2x.png"
    },
    {
        "name": "AirAsia Japan",
        "code": "DJ",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/DJ@2x.png"
    },
    {
        "name": "Gol Transportes A\u00e9reos",
        "code": "G3",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/G3@2x.png"
    },
    {
        "name": "FlyEgypt",
        "code": "FT",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/FT@2x.png"
    },
    {
        "name": "Onur Air",
        "code": "8Q",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/8Q@2x.png"
    },
    {
        "name": "Air Liaison",
        "code": "Q9",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/Q9@2x.png"
    },
    {
        "name": "Air Tindi",
        "code": "8T",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/8T@2x.png"
    },
    {
        "name": "AlbaStar",
        "code": "AP",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/AP@2x.png"
    },
    {
        "name": "fastjet",
        "code": "FN",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/FN@2x.png"
    },
    {
        "name": "Severstal Air",
        "code": "D2",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/D2@2x.png"
    },
    {
        "name": "Portug\u00e1lia",
        "code": "NI",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/NI@2x.png"
    },
    {
        "name": "Sutra Inc.",
        "code": "1K",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/1K@2x.png"
    },
    {
        "name": "Fiji Airways",
        "code": "FJ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/FJ@2x.png"
    },
    {
        "name": "Austrian Airlines",
        "code": "OS",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/OS@2x.png"
    },
    {
        "name": "Ravn Alaska",
        "code": "7H",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/7H@2x.png"
    },
    {
        "name": "Jazz",
        "code": "QK",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/QK@2x.png"
    },
    {
        "name": "Shuttle America",
        "code": "S5",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/S5@2x.png"
    },
    {
        "name": "China Postal Airlines Ltd.",
        "code": "CF",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/CF@2x.png"
    },
    {
        "name": "Sharp Airlines",
        "code": "SH",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/SH@2x.png"
    },
    {
        "name": "Spirit Airlines",
        "code": "NK",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/NK@2x.png"
    },
    {
        "name": "SUN-AIR",
        "code": "ZU",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/ZU@2x.png"
    },
    {
        "name": "Porter Airlines",
        "code": "PD",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/PD@2x.png"
    },
    {
        "name": "UIA",
        "code": "PS",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/PS@2x.png"
    },
    {
        "name": "Qantas",
        "code": "QF",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/QF@2x.png"
    },
    {
        "name": "Euro-Asia Air",
        "code": "6Z",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/6Z@2x.png"
    },
    {
        "name": "Solomon Airlines",
        "code": "IE",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/IE@2x.png"
    },
    {
        "name": "Tectimes Sudamerica",
        "code": "C1",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/C1@2x.png"
    },
    {
        "name": "VivaAerobus",
        "code": "VB",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/VB@2x.png"
    },
    {
        "name": "DAN AIR",
        "code": "DN",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/DN@2x.png"
    },
    {
        "name": "Boliviana de Aviaci\u00f3n",
        "code": "OB",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/OB@2x.png"
    },
    {
        "name": "Vietnam Airlines",
        "code": "VN",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/VN@2x.png"
    },
    {
        "name": "Canadian North",
        "code": "5T",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/5T@2x.png"
    },
    {
        "name": "Blue1",
        "code": "KF",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/KF@2x.png"
    },
    {
        "name": "Go!",
        "code": "G8",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/G8@2x.png"
    },
    {
        "name": "Republic Airlines",
        "code": "YX",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/YX@2x.png"
    },
    {
        "name": "Air Lituanica",
        "code": "LT",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/LT@2x.png"
    },
    {
        "name": "American Airlines",
        "code": "AA",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/AA@2x.png"
    },
    {
        "name": "Air Flamenco",
        "code": "F4",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/F4@2x.png"
    },
    {
        "name": "Air Arabia",
        "code": "G9",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/G9@2x.png"
    },
    {
        "name": "Nesma Airlines",
        "code": "NA",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/NA@2x.png"
    },
    {
        "name": "OAG",
        "code": "CR",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/CR@2x.png"
    },
    {
        "name": "Renegade Air",
        "code": "0R",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/0R@2x.png"
    },
    {
        "name": "Avior Airlines",
        "code": "9V",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/9V@2x.png"
    },
    {
        "name": "Fly540",
        "code": "5H",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/5H@2x.png"
    },
    {
        "name": "Air Transat",
        "code": "TS",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/TS@2x.png"
    },
    {
        "name": "Linea Aerea Carguera de Colombia S.A.",
        "code": "L7",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/L7@2x.png"
    },
    {
        "name": "Air Choice One",
        "code": "3E",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/3E@2x.png"
    },
    {
        "name": "Sundair",
        "code": "SR",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/SR@2x.png"
    },
    {
        "name": "Monacair",
        "code": "QM",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/QM@2x.png"
    },
    {
        "name": "Air Macau",
        "code": "NX",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/NX@2x.png"
    },
    {
        "name": "Japan Airlines",
        "code": "JL",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/JL@2x.png"
    },
    {
        "name": "Air Cargo Germany",
        "code": "6U",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/6U@2x.png"
    },
    {
        "name": "Helijet",
        "code": "JB",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/JB@2x.png"
    },
    {
        "name": "AirAsia Zest",
        "code": "Z2",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/Z2@2x.png"
    },
    {
        "name": "Adria Airways",
        "code": "JP",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/JP@2x.png"
    },
    {
        "name": "PLAY",
        "code": "OG",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/OG@2x.png"
    },
    {
        "name": "Hi Fly",
        "code": "5K",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/5K@2x.png"
    },
    {
        "name": "SkyAlps",
        "code": "BQ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/BQ@2x.png"
    },
    {
        "name": "Air Nostrum",
        "code": "YW",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/YW@2x.png"
    },
    {
        "name": "Envoy Air",
        "code": "MQ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/MQ@2x.png"
    },
    {
        "name": "Euroairlines",
        "code": "Q4",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/Q4@2x.png"
    },
    {
        "name": "easyJet Switzerland",
        "code": "DS",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/DS@2x.png"
    },
    {
        "name": "TAR Aerolineas",
        "code": "YQ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/YQ@2x.png"
    },
    {
        "name": "Norwegian Air International",
        "code": "D8",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/D8@2x.png"
    },
    {
        "name": "Miami Air International",
        "code": "LL",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/LL@2x.png"
    },
    {
        "name": "Fuji Dream Airlines",
        "code": "JH",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/JH@2x.png"
    },
    {
        "name": "Air Burkina",
        "code": "2J",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/2J@2x.png"
    },
    {
        "name": "Rossiya Airlines",
        "code": "FV",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/FV@2x.png"
    },
    {
        "name": "Binter Canarias",
        "code": "NT",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/NT@2x.png"
    },
    {
        "name": "Volaris Costa Rica",
        "code": "Q6",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/Q6@2x.png"
    },
    {
        "name": "Corendon Airlines",
        "code": "XC",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/XC@2x.png"
    },
    {
        "name": "Ghadames Air Transport",
        "code": "NJ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/NJ@2x.png"
    },
    {
        "name": "Halcyonair",
        "code": "7Z",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/7Z@2x.png"
    },
    {
        "name": "VLM Airlines",
        "code": "VG",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/VG@2x.png"
    },
    {
        "name": "Izhavia",
        "code": "I8",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/I8@2x.png"
    },
    {
        "name": "Silkair",
        "code": "MI",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/MI@2x.png"
    },
    {
        "name": "Avianca Ecuador",
        "code": "2K",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/2K@2x.png"
    },
    {
        "name": "SKS Airways",
        "code": "KI",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/KI@2x.png"
    },
    {
        "name": "French Bee",
        "code": "BF",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/BF@2x.png"
    },
    {
        "name": "Vladivostok Air",
        "code": "XF",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/XF@2x.png"
    },
    {
        "name": "Radixx Solutions International, Inc.",
        "code": "1D",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/1D@2x.png"
    },
    {
        "name": "One Jet, Inc.",
        "code": "J1",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/J1@2x.png"
    },
    {
        "name": "TAB - Transportes A\u00e9reos Bolivianos",
        "code": "B1",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/B1@2x.png"
    },
    {
        "name": "Small Planet Airlines",
        "code": "P7",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/P7@2x.png"
    },
    {
        "name": "Cargolux",
        "code": "CV",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/CV@2x.png"
    },
    {
        "name": "Gambia International Airlines",
        "code": "GC",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/GC@2x.png"
    },
    {
        "name": "Air India Express",
        "code": "IX",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/IX@2x.png"
    },
    {
        "name": "Freebird Airlines",
        "code": "FH",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/FH@2x.png"
    },
    {
        "name": "StarFlyer",
        "code": "7G",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/7G@2x.png"
    },
    {
        "name": "ACT Havayollari A.S.",
        "code": "9T",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/9T@2x.png"
    },
    {
        "name": "Chu Kong Passenger Transport Co. Ltd.",
        "code": "3A",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/3A@2x.png"
    },
    {
        "name": "Libyan Airlines",
        "code": "LN",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/LN@2x.png"
    },
    {
        "name": "Jordan Aviation",
        "code": "R5",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/R5@2x.png"
    },
    {
        "name": "Sky Wings Airlines",
        "code": "ND",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/ND@2x.png"
    },
    {
        "name": "HOP!",
        "code": "A5",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/A5@2x.png"
    },
    {
        "name": "SmartWings",
        "code": "QS",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/QS@2x.png"
    },
    {
        "name": "Srilankan Airlines",
        "code": "UL",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/UL@2x.png"
    },
    {
        "name": "Tandem Aero",
        "code": "TQ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/TQ@2x.png"
    },
    {
        "name": "9 Air",
        "code": "AQ",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/AQ@2x.png"
    },
    {
        "name": "Mid Africa Aviation",
        "code": "8G",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/8G@2x.png"
    },
    {
        "name": "Nok Air",
        "code": "DD",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/DD@2x.png"
    },
    {
        "name": "Air Seoul",
        "code": "RS",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/RS@2x.png"
    },
    {
        "name": "TACA Airlines",
        "code": "TA",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/TA@2x.png"
    },
    {
        "name": "Air India Express",
        "code": "I5",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/I5@2x.png"
    },
    {
        "name": "Alpha Air Transport",
        "code": "7U",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/7U@2x.png"
    },
    {
        "name": "Chair Airlines",
        "code": "GM",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/GM@2x.png"
    },
    {
        "name": "Avion Express",
        "code": "X9",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/X9@2x.png"
    },
    {
        "name": "Maldivian",
        "code": "Q2",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/Q2@2x.png"
    },
    {
        "name": "Armenia Airways",
        "code": "6A",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/6A@2x.png"
    },
    {
        "name": "FlyOne",
        "code": "5F",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/5F@2x.png"
    },
    {
        "name": "LANHSA",
        "code": "00",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/00@2x.png"
    },
    {
        "name": "Trans States Airlines",
        "code": "AX",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/AX@2x.png"
    },
    {
        "name": "Belair Airlines",
        "code": "4T",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/4T@2x.png"
    },
    {
        "name": "Tibet Airlines",
        "code": "TV",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/TV@2x.png"
    },
    {
        "name": "FlyALS",
        "code": "0F",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/0F@2x.png"
    },
    {
        "name": "Avion Express Malta",
        "code": "4X",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/4X@2x.png"
    },
    {
        "name": "Skippers Aviation",
        "code": "HK",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/HK@2x.png"
    },
    {
        "name": "Tianjin Airlines",
        "code": "GS",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/GS@2x.png"
    },
    {
        "name": "Air Italy",
        "code": "IG",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/IG@2x.png"
    },
    {
        "name": "Azur Air",
        "code": "ZF",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/ZF@2x.png"
    },
    {
        "name": "China Southern Airlines",
        "code": "CZ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/CZ@2x.png"
    },
    {
        "name": "Hawaiian Airlines",
        "code": "HA",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/HA@2x.png"
    },
    {
        "name": "Bonza",
        "code": "AB",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/AB@2x.png"
    },
    {
        "name": "Wizz Air Ukraine",
        "code": "WU",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/WU@2x.png"
    },
    {
        "name": "Air Corsica",
        "code": "XK",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/XK@2x.png"
    },
    {
        "name": "Qazaq Air",
        "code": "IQ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/IQ@2x.png"
    },
    {
        "name": "FlexFlight",
        "code": "W2",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/W2@2x.png"
    },
    {
        "name": "Ethiopian Airlines",
        "code": "ET",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/ET@2x.png"
    },
    {
        "name": "Punta Europa",
        "code": "PU",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/PU@2x.png"
    },
    {
        "name": "Air Excursion, LLC",
        "code": "X4",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/X4@2x.png"
    },
    {
        "name": "Windrose Airlines",
        "code": "7W",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/7W@2x.png"
    },
    {
        "name": "Uni-Top Airlines",
        "code": "UW",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/UW@2x.png"
    },
    {
        "name": "Aeromexico",
        "code": "AM",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/AM@2x.png"
    },
    {
        "name": "Bahamasair",
        "code": "UP",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/UP@2x.png"
    },
    {
        "name": "El Al Israel Airlines",
        "code": "LY",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/LY@2x.png"
    },
    {
        "name": "APG Airlines",
        "code": "GP",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/GP@2x.png"
    },
    {
        "name": "Cargo Three Inc. dba Pan Air Cargo",
        "code": "3J",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/3J@2x.png"
    },
    {
        "name": "Libyan Wings",
        "code": "YL",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/YL@2x.png"
    },
    {
        "name": "TAP Portugal",
        "code": "TP",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/TP@2x.png"
    },
    {
        "name": "LAN Express",
        "code": "LU",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/LU@2x.png"
    },
    {
        "name": "FlyArystan",
        "code": "0Y",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/0Y@2x.png"
    },
    {
        "name": "Air Antilles Express",
        "code": "3S",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/3S@2x.png"
    },
    {
        "name": "Afrijet Business Service",
        "code": "J7",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/J7@2x.png"
    },
    {
        "name": "Nas Air",
        "code": "XY",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/XY@2x.png"
    },
    {
        "name": "Trade Air",
        "code": "C3",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/C3@2x.png"
    },
    {
        "name": "Turkish Airlines",
        "code": "TK",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/TK@2x.png"
    },
    {
        "name": "MNG Airlines",
        "code": "MB",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/MB@2x.png"
    },
    {
        "name": "Biman Bangladesh Airlines",
        "code": "BG",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/BG@2x.png"
    },
    {
        "name": "8165343 Canada Inc. dba Air Canada rouge",
        "code": "RV",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/RV@2x.png"
    },
    {
        "name": "Ibex Airlines",
        "code": "FW",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/FW@2x.png"
    },
    {
        "name": "Nextjet",
        "code": "2N",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/2N@2x.png"
    },
    {
        "name": "Blue Islands",
        "code": "SI",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/SI@2x.png"
    },
    {
        "name": "Germanwings",
        "code": "4U",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/4U@2x.png"
    },
    {
        "name": "Aero K",
        "code": "RF",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/RF@2x.png"
    },
    {
        "name": "L'Odyssey",
        "code": "V9",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/V9@2x.png"
    },
    {
        "name": "Meraj Airlines",
        "code": "0I",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/0I@2x.png"
    },
    {
        "name": "Tigerair Australia",
        "code": "TT",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/TT@2x.png"
    },
    {
        "name": "Jetstar Japan",
        "code": "GK",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/GK@2x.png"
    },
    {
        "name": "E-Savtravel",
        "code": "L1",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/L1@2x.png"
    },
    {
        "name": "Air Arabia Jordan",
        "code": "9P",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/9P@2x.png"
    },
    {
        "name": "Uzbekistan Airways",
        "code": "HY",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/HY@2x.png"
    },
    {
        "name": "Thai Lion Air",
        "code": "SL",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/SL@2x.png"
    },
    {
        "name": "Calm Air International",
        "code": "MO",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/MO@2x.png"
    },
    {
        "name": "Everts Air Cargo",
        "code": "5V",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/5V@2x.png"
    },
    {
        "name": "Blue Bird Airways",
        "code": "BZ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/BZ@2x.png"
    },
    {
        "name": "Air Excel",
        "code": "0X",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/0X@2x.png"
    },
    {
        "name": "Nesma Airlines",
        "code": "NE",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/NE@2x.png"
    },
    {
        "name": "SalamAir",
        "code": "OV",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/OV@2x.png"
    },
    {
        "name": "Germania",
        "code": "ST",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/ST@2x.png"
    },
    {
        "name": "Sky Mali",
        "code": "ML",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/ML@2x.png"
    },
    {
        "name": "Safair",
        "code": "FA",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/FA@2x.png"
    },
    {
        "name": "EgyptAir",
        "code": "MS",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/MS@2x.png"
    },
    {
        "name": "Saudia",
        "code": "SV",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/SV@2x.png"
    },
    {
        "name": "Islena de Inversiones S.A. de C.V.dba Islena Airlines",
        "code": "WC",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/WC@2x.png"
    },
    {
        "name": "Niger Airlines",
        "code": "6N",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/6N@2x.png"
    },
    {
        "name": "Quikjet Cargo Airlines Pvt. Ltd",
        "code": "QO",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/QO@2x.png"
    },
    {
        "name": "Azimuth",
        "code": "A4",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/A4@2x.png"
    },
    {
        "name": "China Eastern Airlines",
        "code": "MU",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/MU@2x.png"
    },
    {
        "name": "Loganair",
        "code": "LM",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/LM@2x.png"
    },
    {
        "name": "Airlink",
        "code": "4Z",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/4Z@2x.png"
    },
    {
        "name": "Royal Flight",
        "code": "RL",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/RL@2x.png"
    },
    {
        "name": "Volotea",
        "code": "V7",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/V7@2x.png"
    },
    {
        "name": "Public Charters",
        "code": "P1",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/P1@2x.png"
    },
    {
        "name": "Aeromar",
        "code": "VW",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/VW@2x.png"
    },
    {
        "name": "XL Airways France",
        "code": "SE",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/SE@2x.png"
    },
    {
        "name": "Chautauqua Airlines",
        "code": "RP",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/RP@2x.png"
    },
    {
        "name": "Hahn Air",
        "code": "H1",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/H1@2x.png"
    },
    {
        "name": "Philippine Airlines",
        "code": "PR",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/PR@2x.png"
    },
    {
        "name": "Ningxia Cargo Airlines CO.,LTD",
        "code": "HT",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/HT@2x.png"
    },
    {
        "name": "AS SALAAM AIR",
        "code": "0W",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/0W@2x.png"
    },
    {
        "name": "Sqiva Sistem",
        "code": "Q1",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/Q1@2x.png"
    },
    {
        "name": "Caribbean Airlines",
        "code": "BW",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/BW@2x.png"
    },
    {
        "name": "AJet",
        "code": "VF",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/VF@2x.png"
    },
    {
        "name": "Lufthansa Systems",
        "code": "S1",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/S1@2x.png"
    },
    {
        "name": "WOW Air ehf",
        "code": "WW",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/WW@2x.png"
    },
    {
        "name": "Comair",
        "code": "MN",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/MN@2x.png"
    },
    {
        "name": "Panama Airways",
        "code": "8A",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/8A@2x.png"
    },
    {
        "name": "Avianca",
        "code": "AV",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/AV@2x.png"
    },
    {
        "name": "Kan Air",
        "code": "K8",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/K8@2x.png"
    },
    {
        "name": "Air Alsie",
        "code": "6I",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/6I@2x.png"
    },
    {
        "name": "Air Algerie",
        "code": "AH",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/AH@2x.png"
    },
    {
        "name": "AnadoluJet",
        "code": "0T",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/0T@2x.png"
    },
    {
        "name": "Insel Air",
        "code": "8I",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/8I@2x.png"
    },
    {
        "name": "SkyUp Airlines",
        "code": "PQ",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/PQ@2x.png"
    },
    {
        "name": "Kyrgyz Air",
        "code": "KH",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/KH@2x.png"
    },
    {
        "name": "Jet2.com",
        "code": "LS",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/LS@2x.png"
    },
    {
        "name": "Air Kiribati Limited",
        "code": "IK",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/IK@2x.png"
    },
    {
        "name": "Brindabella Airlines",
        "code": "FQ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/FQ@2x.png"
    },
    {
        "name": "Telair International GmbH",
        "code": "T8",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/T8@2x.png"
    },
    {
        "name": "ChallengAir",
        "code": "1I",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/1I@2x.png"
    },
    {
        "name": "Rotana Jet",
        "code": "RG",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/RG@2x.png"
    },
    {
        "name": "Air Premia",
        "code": "YP",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/YP@2x.png"
    },
    {
        "name": "Skymark Airlines",
        "code": "BC",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/BC@2x.png"
    },
    {
        "name": "Loong Air",
        "code": "GJ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/GJ@2x.png"
    },
    {
        "name": "Air Namibia",
        "code": "SW",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/SW@2x.png"
    },
    {
        "name": "Air Seychelles",
        "code": "HM",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/HM@2x.png"
    },
    {
        "name": "Air France",
        "code": "AF",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/AF@2x.png"
    },
    {
        "name": "Great Lakes Airlines",
        "code": "ZK",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/ZK@2x.png"
    },
    {
        "name": "Thai Smile",
        "code": "WE",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/WE@2x.png"
    },
    {
        "name": "Jetairfly",
        "code": "TB",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/TB@2x.png"
    },
    {
        "name": "Caribbean Air Export Import Inc.",
        "code": "CB",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/CB@2x.png"
    },
    {
        "name": "Hi Air",
        "code": "4H",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/4H@2x.png"
    },
    {
        "name": "LASER Airlines",
        "code": "QL",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/QL@2x.png"
    },
    {
        "name": "Flair Airlines",
        "code": "F8",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/F8@2x.png"
    },
    {
        "name": "SkyFru",
        "code": "K1",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/K1@2x.png"
    },
    {
        "name": "SkyJet",
        "code": "M8",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/M8@2x.png"
    },
    {
        "name": "Santa Barbara Airlines",
        "code": "S3",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/S3@2x.png"
    },
    {
        "name": "Sun Express",
        "code": "XQ",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/XQ@2x.png"
    },
    {
        "name": "Avianca Brazil",
        "code": "O6",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/O6@2x.png"
    },
    {
        "name": "Scoot",
        "code": "TZ",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/TZ@2x.png"
    },
    {
        "name": "Iberojet",
        "code": "E9",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/E9@2x.png"
    },
    {
        "name": "Norwegian Air",
        "code": "DI",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/DI@2x.png"
    },
    {
        "name": "Hainan Airlines",
        "code": "HU",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/HU@2x.png"
    },
    {
        "name": "Transavia",
        "code": "HV",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/HV@2x.png"
    },
    {
        "name": "St Barth Commuter",
        "code": "PV",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/PV@2x.png"
    },
    {
        "name": "White Airways",
        "code": "WI",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/WI@2x.png"
    },
    {
        "name": "JSC Transport Automated InformationSystems - TAIS",
        "code": "1M",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/1M@2x.png"
    },
    {
        "name": "Air Sunshine Inc.",
        "code": "YI",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/YI@2x.png"
    },
    {
        "name": "Ibom Air",
        "code": "QI",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/QI@2x.png"
    },
    {
        "name": "Airlines PNG",
        "code": "CG",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/CG@2x.png"
    },
    {
        "name": "BB Airways",
        "code": "BO",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/BO@2x.png"
    },
    {
        "name": "INFINI Travel Information, Inc.",
        "code": "1F",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/1F@2x.png"
    },
    {
        "name": "Insel Air",
        "code": "7I",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/7I@2x.png"
    },
    {
        "name": "KrasAvia",
        "code": "KV",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/KV@2x.png"
    },
    {
        "name": "Ariana Afghan Airlines",
        "code": "FG",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/FG@2x.png"
    },
    {
        "name": "Arik Air",
        "code": "W3",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/W3@2x.png"
    },
    {
        "name": "Mandarin Airlines",
        "code": "AE",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/AE@2x.png"
    },
    {
        "name": "PAL Express",
        "code": "2P",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/2P@2x.png"
    },
    {
        "name": "Vietravel Airlines",
        "code": "VU",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/VU@2x.png"
    },
    {
        "name": "NOVA Airlines",
        "code": "O9",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/O9@2x.png"
    },
    {
        "name": "Aerolineas Sosa",
        "code": "S0",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/S0@2x.png"
    },
    {
        "name": "Redemption Inc.",
        "code": "2O",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/2O@2x.png"
    },
    {
        "name": "Avelo Airlines",
        "code": "XP",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/XP@2x.png"
    },
    {
        "name": "Charter Air Transport, Inc.",
        "code": "VC",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/VC@2x.png"
    },
    {
        "name": "Aer Lingus",
        "code": "EI",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/EI@2x.png"
    },
    {
        "name": "Conviasa",
        "code": "V0",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/V0@2x.png"
    },
    {
        "name": "Lufthansa CityLine",
        "code": "CL",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/CL@2x.png"
    },
    {
        "name": "Lynx Aviation",
        "code": "L3",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/L3@2x.png"
    },
    {
        "name": "Laparkan Airways, Inc.",
        "code": "LE",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/LE@2x.png"
    },
    {
        "name": "PopulAir",
        "code": "HP",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/HP@2x.png"
    },
    {
        "name": "Aeronautical Telecommunications Ltd.(AEROTEL)",
        "code": "XI",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/XI@2x.png"
    },
    {
        "name": "Universal Air",
        "code": "VO",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/VO@2x.png"
    },
    {
        "name": "Sunday Airlines",
        "code": "0S",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/0S@2x.png"
    },
    {
        "name": "Air KBZ",
        "code": "K7",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/K7@2x.png"
    },
    {
        "name": "Far Eastern Air Transport",
        "code": "FE",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/FE@2x.png"
    },
    {
        "name": "Aurigny Air Services",
        "code": "GR",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/GR@2x.png"
    },
    {
        "name": "Air Do",
        "code": "HD",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/HD@2x.png"
    },
    {
        "name": "Mahan Airlines",
        "code": "W5",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/W5@2x.png"
    },
    {
        "name": "Ultimate Jetcharters",
        "code": "UE",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/UE@2x.png"
    },
    {
        "name": "Thai AirAsia X",
        "code": "XJ",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/XJ@2x.png"
    },
    {
        "name": "Helvetic Airways",
        "code": "2L",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/2L@2x.png"
    },
    {
        "name": "Electronic Data Systems Corporation",
        "code": "1Y",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/1Y@2x.png"
    },
    {
        "name": "Malta Air",
        "code": "AL",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/AL@2x.png"
    },
    {
        "name": "Asian Wings Airways Limited",
        "code": "YJ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/YJ@2x.png"
    },
    {
        "name": "Aerotranscargo",
        "code": "F5",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/F5@2x.png"
    },
    {
        "name": "Marsland Aviation",
        "code": "M7",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/M7@2x.png"
    },
    {
        "name": "LATAM Brasil",
        "code": "JJ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/JJ@2x.png"
    },
    {
        "name": "Novoair",
        "code": "VQ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/VQ@2x.png"
    },
    {
        "name": "Bering Air",
        "code": "8E",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/8E@2x.png"
    },
    {
        "name": "BA Cityflyer",
        "code": "CJ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/CJ@2x.png"
    },
    {
        "name": "Tailwind Airlines",
        "code": "TI",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/TI@2x.png"
    },
    {
        "name": "Tigerair Mandala",
        "code": "RI",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/RI@2x.png"
    },
    {
        "name": "Qatar Airways",
        "code": "QR",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/QR@2x.png"
    },
    {
        "name": "Air Japan",
        "code": "NQ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/NQ@2x.png"
    },
    {
        "name": "Fuzhou Airlines",
        "code": "FU",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/FU@2x.png"
    },
    {
        "name": "Air Caucasus",
        "code": "UY",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/UY@2x.png"
    },
    {
        "name": "ZIPAIR Tokyo",
        "code": "ZG",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/ZG@2x.png"
    },
    {
        "name": "Raya Airways Sdn. Bhd.dba Raya Airways",
        "code": "TH",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/TH@2x.png"
    },
    {
        "name": "TurboJET",
        "code": "8S",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/8S@2x.png"
    },
    {
        "name": "Almasria Universal Airlines",
        "code": "UJ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/UJ@2x.png"
    },
    {
        "name": "Yakutia Airlines",
        "code": "R3",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/R3@2x.png"
    },
    {
        "name": "DoKaSch",
        "code": "3D",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/3D@2x.png"
    },
    {
        "name": "Mistral Air",
        "code": "M4",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/M4@2x.png"
    },
    {
        "name": "Condor",
        "code": "DF",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/DF@2x.png"
    },
    {
        "name": "FlyBosnia",
        "code": "6W",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/6W@2x.png"
    },
    {
        "name": "Flyadeal",
        "code": "F3",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/F3@2x.png"
    },
    {
        "name": "Qeshm Air",
        "code": "QB",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/QB@2x.png"
    },
    {
        "name": "Buta Airways",
        "code": "55",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/55@2x.png"
    },
    {
        "name": "Viva Air",
        "code": "VV",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/VV@2x.png"
    },
    {
        "name": "Arajet",
        "code": "DM",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/DM@2x.png"
    },
    {
        "name": "Flightlink",
        "code": "YS",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/YS@2x.png"
    },
    {
        "name": "Travel Service Slovensko",
        "code": "6D",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/6D@2x.png"
    },
    {
        "name": "Animawings",
        "code": "A2",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/A2@2x.png"
    },
    {
        "name": "MHS Aviation",
        "code": "M2",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/M2@2x.png"
    },
    {
        "name": "Shandong Airlines",
        "code": "SC",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/SC@2x.png"
    },
    {
        "name": "Liat",
        "code": "LI",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/LI@2x.png"
    },
    {
        "name": "Yeti Airlines Domestic Pvt. Ltd.",
        "code": "YT",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/YT@2x.png"
    },
    {
        "name": "EuroAtlantic Airways S.A.",
        "code": "YU",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/YU@2x.png"
    },
    {
        "name": "Trenitalia",
        "code": "7T",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/7T@2x.png"
    },
    {
        "name": "CemAir",
        "code": "5Z",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/5Z@2x.png"
    },
    {
        "name": "FlyOne",
        "code": "3F",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/3F@2x.png"
    },
    {
        "name": "Hewlett-Packard (Schweiz) GmbH",
        "code": "1C",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/1C@2x.png"
    },
    {
        "name": "Air C\u00f4te d'Ivoire",
        "code": "HF",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/HF@2x.png"
    },
    {
        "name": "Tigerair Philippines",
        "code": "DG",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/DG@2x.png"
    },
    {
        "name": "BVI Airways",
        "code": "XV",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/XV@2x.png"
    },
    {
        "name": "Silver Air",
        "code": "0P",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/0P@2x.png"
    },
    {
        "name": "Nouvelair",
        "code": "BJ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/BJ@2x.png"
    },
    {
        "name": "West Link Airlines",
        "code": "9L",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/9L@2x.png"
    },
    {
        "name": "Air Botswana",
        "code": "BP",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/BP@2x.png"
    },
    {
        "name": "East African Safari Air",
        "code": "B5",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/B5@2x.png"
    },
    {
        "name": "Tatarstan Airlines",
        "code": "U9",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/U9@2x.png"
    },
    {
        "name": "Northwest",
        "code": "0E",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/0E@2x.png"
    },
    {
        "name": "Antrak Air",
        "code": "O4",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/O4@2x.png"
    },
    {
        "name": "Travel Service Polska Sp. z.o.o.",
        "code": "3Z",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/3Z@2x.png"
    },
    {
        "name": "Warbelow's Air Ventures",
        "code": "4W",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/4W@2x.png"
    },
    {
        "name": "IrAero",
        "code": "IO",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/IO@2x.png"
    },
    {
        "name": "Miami Air Lease, Inc.",
        "code": "MG",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/MG@2x.png"
    },
    {
        "name": "Lignes Aeriennes Congolaises",
        "code": "4V",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/4V@2x.png"
    },
    {
        "name": "Qanot Sharq",
        "code": "HH",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/HH@2x.png"
    },
    {
        "name": "United Airlines",
        "code": "UA",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/UA@2x.png"
    },
    {
        "name": "Xiamen Airlines",
        "code": "MF",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/MF@2x.png"
    },
    {
        "name": "Alrosa",
        "code": "6R",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/6R@2x.png"
    },
    {
        "name": "UPS",
        "code": "5X",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/5X@2x.png"
    },
    {
        "name": "Shaheen Air",
        "code": "NL",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/NL@2x.png"
    },
    {
        "name": "LAM Mozambique Airlines",
        "code": "TM",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/TM@2x.png"
    },
    {
        "name": "Arkia",
        "code": "IZ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/IZ@2x.png"
    },
    {
        "name": "Corsair International",
        "code": "SS",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/SS@2x.png"
    },
    {
        "name": "Eva Air",
        "code": "BR",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/BR@2x.png"
    },
    {
        "name": "Jet Aviation Business",
        "code": "PP",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/PP@2x.png"
    },
    {
        "name": "Wideroe",
        "code": "WF",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/WF@2x.png"
    },
    {
        "name": "Boutique Air",
        "code": "4B",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/4B@2x.png"
    },
    {
        "name": "Spring Airlines",
        "code": "9C",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/9C@2x.png"
    },
    {
        "name": "Tropic Air Limited",
        "code": "9N",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/9N@2x.png"
    },
    {
        "name": "Air Service Liege",
        "code": "L4",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/L4@2x.png"
    },
    {
        "name": "Martinair",
        "code": "MP",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/MP@2x.png"
    },
    {
        "name": "Hesa Airlines",
        "code": "H8",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/H8@2x.png"
    },
    {
        "name": "Air Tahiti",
        "code": "VT",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/VT@2x.png"
    },
    {
        "name": "Fly Jordan",
        "code": "F0",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/F0@2x.png"
    },
    {
        "name": "Qingdao Airlines",
        "code": "QW",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/QW@2x.png"
    },
    {
        "name": "Villa Air",
        "code": "VP",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/VP@2x.png"
    },
    {
        "name": "Air Greenland",
        "code": "GL",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/GL@2x.png"
    },
    {
        "name": "TransNusa",
        "code": "8B",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/8B@2x.png"
    },
    {
        "name": "H\u00e9li S\u00e9curit\u00e9 H\u00e9licopter Airline",
        "code": "HS",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/HS@2x.png"
    },
    {
        "name": "Air Zimbabwe",
        "code": "UM",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/UM@2x.png"
    },
    {
        "name": "Shanghai Airlines",
        "code": "FM",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/FM@2x.png"
    },
    {
        "name": "Eswatini Air",
        "code": "RN",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/RN@2x.png"
    },
    {
        "name": "Nature Air",
        "code": "5C",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/5C@2x.png"
    },
    {
        "name": "Scoot",
        "code": "TR",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/TR@2x.png"
    },
    {
        "name": "DOT LT",
        "code": "R6",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/R6@2x.png"
    },
    {
        "name": "Eastern Airlines, LLC",
        "code": "2D",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/2D@2x.png"
    },
    {
        "name": "Joy Air",
        "code": "JR",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/JR@2x.png"
    },
    {
        "name": "Wings Air",
        "code": "IW",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/IW@2x.png"
    },
    {
        "name": "Volga-Dnepr Airlines",
        "code": "VI",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/VI@2x.png"
    },
    {
        "name": "TUI fly",
        "code": "X3",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/X3@2x.png"
    },
    {
        "name": "Discovery Airways",
        "code": "DO",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/DO@2x.png"
    },
    {
        "name": "Colorful Guizhou Airlines",
        "code": "GY",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/GY@2x.png"
    },
    {
        "name": "Fly Namibia",
        "code": "WV",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/WV@2x.png"
    },
    {
        "name": "TIK Systems",
        "code": "T1",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/T1@2x.png"
    },
    {
        "name": "MetroJet",
        "code": "7K",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/7K@2x.png"
    },
    {
        "name": "NAYSA",
        "code": "ZN",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/ZN@2x.png"
    },
    {
        "name": "Eagle Atlantic Airlines",
        "code": "E2",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/E2@2x.png"
    },
    {
        "name": "Discover",
        "code": "4Y",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/4Y@2x.png"
    },
    {
        "name": "Sun Country Airlines",
        "code": "SY",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/SY@2x.png"
    },
    {
        "name": "Skywings Asia Airlines Co., Ltd.",
        "code": "ZA",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/ZA@2x.png"
    },
    {
        "name": "Swiftair",
        "code": "WT",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/WT@2x.png"
    },
    {
        "name": "Level",
        "code": "VK",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/VK@2x.png"
    },
    {
        "name": "Sun Air Express",
        "code": "6G",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/6G@2x.png"
    },
    {
        "name": "Red Sea Airlines",
        "code": "4S",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/4S@2x.png"
    },
    {
        "name": "Compass Airlines",
        "code": "CP",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/CP@2x.png"
    },
    {
        "name": "Nakina Air Service",
        "code": "T2",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/T2@2x.png"
    },
    {
        "name": "China United Airlines",
        "code": "KN",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/KN@2x.png"
    },
    {
        "name": "DHL Aviation EEMEA B.S.C.(c)",
        "code": "ES",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/ES@2x.png"
    },
    {
        "name": "Afric Aviation",
        "code": "L8",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/L8@2x.png"
    },
    {
        "name": "Aeropelican Air Services",
        "code": "OT",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/OT@2x.png"
    },
    {
        "name": "Kharkiv Airlines",
        "code": "KW",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/KW@2x.png"
    },
    {
        "name": "Lynx Air",
        "code": "Y9",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/Y9@2x.png"
    },
    {
        "name": "Okay Airways",
        "code": "BK",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/BK@2x.png"
    },
    {
        "name": "Navitaire",
        "code": "1N",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/1N@2x.png"
    },
    {
        "name": "iFly Airlines",
        "code": "F7",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/F7@2x.png"
    },
    {
        "name": "Alliance Air",
        "code": "9I",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/9I@2x.png"
    },
    {
        "name": "Jin Air",
        "code": "LJ",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/LJ@2x.png"
    },
    {
        "name": "Aviacon Zitotrans Air Company JSC",
        "code": "ZR",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/ZR@2x.png"
    },
    {
        "name": "Hong Kong Express Airways",
        "code": "UO",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/UO@2x.png"
    },
    {
        "name": "Tradewind Aviation",
        "code": "TJ",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/TJ@2x.png"
    },
    {
        "name": "Tunisair",
        "code": "TU",
        "is_lowcost": false,
        "logo": "https://pics.avs.io/200/200/TU@2x.png"
    },
    {
        "name": "Mango",
        "code": "JE",
        "is_lowcost": true,
        "logo": "https://pics.avs.io/200/200/JE@2x.png"
    }
]